/*
Description: flex++ ("full Prompt") variant of the PromptEMR injector.

Selected instead of PromptInject.ts when the new_prompt_integration feature flag
is on (see DOMEvaluator). Same scrapers as PromptInject, but instead of ~40 flat
per-question asks it emits ONE nested Flex question for the whole document using
the flex++ reserved-key contract (LambdaAPI/FlexPlusPlus.md), and fills the
nested answer back through a parallel tree of the scraped closures.

Original description: This is the file that will hanlde interacting with the PromptEMR

Notes:
    All Injectors need the following functions:
        getQuestions
        answerQuestions (Consider combining these and making the single a private function)
        answerQuestion

Status: 
    Boatload of "Measurement" questions (Nuking Long Answer)
    Plan shows up as a Long Answer question...


TODO: 
    Scrape the dyanmic tokens - the .Firstname and such...

Prompt Specific Notes:
    Top Level: class: "items-start"
        Child
            Long Answers:
                class: "q-pl-md" (ID is telling us the section)
                Specifically General Note and Plan:
                    class:q-mb-md (Subjective, Objective, Assessment, Plan)
                    var q = document.querySelectorAll('.q-mb-md')
                    q[0].children[0].getAttribute("label") // Get's us the subjective label
                    var sub = q[0].querySelector("textarea")
                    sub.value = "This is a test of the emergency broadcast system..."

            CPT Codes:
                //class: "q-pa-md"
                role="combobox"
                document.querySelectorAll('[role="combobox"]')
                // In this case it was the 3rd one
                var cpt = document.querySelectorAll('[role="combobox"]')[2]
                var questionLabel = getParentSubtitle(cpt)

                # Getting the choices to show up...
                cpt.dispatchEvent(eventFactory("focusin"))
                cpt.dispatchEvent(eventFactory("click"))

                // then the options are in a listbox with role="listbox"
                // We can get the options with
                var lBox = document.querySelectorAll('[role="listbox"]')[0]
                var choices = lBox.querySelectorAll(".q-item__section")
                    choices[14].children[0].textContent // This is the code
                    choices[14].children[1].textContent // This is the description
                    // To Click it
                    if (!choices[14].parentElement.classList.contains("q-item--active")){
                        choices[14].click() // (Toggles so we have to check it first)
                    }

            // Choose All Question - 
            class:"q-pa-md"    
            var q = document.querySelectorAll('.q-pa-md')[6]
            var questionLabel = getChildSubtitle(q)
            var choices = q.querySelectorAll(".q-px-md")
                choices[0].textContent // This is the choice text

                // To Click it
                if (!c.querySelector(".q-checkbox__inner").classList.contains("q-checkbox__inner--truthy"))){
                    c.querySelector(".q-checkbox__inner").click() // This is how we click it
                }
            
            // Multiple Choice ("radioGroup")
            class: "q-pa-md"
            var q = document.querySelectorAll('.q-pa-md')[7]
            qs[7].querySelector(".radioGroup") != null
            var questionLabel = getChildSubtitle(q)
            var choices = q.querySelectorAll("button")
                // This is the choice text
                choices[0].querySelector(".q-btn__content").firstChild.firstChild.textContent 

                // To Click it
                if (!choices[0].classList.contains("bg-p-blue100"))){
                    choices[0].click() // (Toggles so we have to check it first)
                }


            // Long Answer
            class: "q-pa-md"
            var q = document.querySelectorAll('.q-pa-md')[8]
            var questionLabel = getChildSubtitle(q)
            var answer = q.querySelector("textarea")
                answer.value = "This is a test of the emergency broadcast system..."


            // Looking at templates...
                // We can get the templates with
                var t = findTemplate(document)
                t.click()   // Shows the template manager

                var tDialog = document.querySelector('.q-dialog')
                var filter = tDialog.querySelectorAll(".q-field__inner")
                    # 0 is Body Part
                    # 1 is Type ("Subjective, ...")
                    # 2 is Author
                    # 3 is Search
                tDialog.querySelectorAll(".q-field__inner")[0].firstChild.click()

                // We can get the options with
                var lBox = document.querySelectorAll('[role="listbox"]')[0]
                var choices = lBox.querySelectorAll(".q-px-md")
                    // It possible that the first 2 options are not what we want
                    // 0 is search
                    // 1 is select all and clear
                    // 2 is the first option
                    // Not the case for type
                
                // To click on one of the choices
                    choices[0].querySelector('[role="checkbox"]').click()
                
                // For the Type, try to find an exact match in the question, if there is none, don't select anything
                // Note: we will have to clear all the options first
                // Note: we will have to wait for the template list to load
                
                // Scraping the templates after searching 
                var templates = tDialog.querySelector(".q-table__grid-content").children
                # We are grabbing the outer element to get more context. Now strip away some of that context
                templates[0]textContent.split("...see more")[0].trim() // This is the template name


                // To close the template manager
                findElementOfTypeWithText(tDialog, "i", "close").click()




*/

import type { FocusCaptureSource, SectionRead } from './NoteFocusCapture.ts';
import { promptNotePage } from './PromptCapture.ts';
export { getSchedule } from './PromptSchedule.ts';

// async function getPageInfo(){
/* Blur overlay shown while scanning and filling (same as WebPT2 / Raintree). */
/* Start the Blur Overlay */
const OVERLAY_ID = 'BlurOverlay';
const ACTIVE_CLASS = 'blur-overlay-active';
const CSS_ID = 'BlurOverlayStyles';

let overlayEl, msgEl, closeBtn;
let usingBackdrop = true;
let lastFocused = null;

function injectStyles() {
  if (document.getElementById(CSS_ID)) return;
  const style = document.createElement('style');
  style.id = CSS_ID;
  style.textContent = `
     /* Root toggle classes */
     html.${ACTIVE_CLASS} { overflow: hidden; }
     body.${ACTIVE_CLASS} { overflow: hidden; }
  
     /* Fallback blur for browsers without backdrop-filter */
     html.${ACTIVE_CLASS} body > *:not(#${OVERLAY_ID}) {
       filter: blur(var(--blur-overlay-amount, 8px)) saturate(0.9);
       pointer-events: none;
       user-select: none;
     }
  
     /* Overlay container */
     #${OVERLAY_ID} {
       position: fixed;
       inset: 0;
       /* Brand color (tealish green) */
       --brand-color: rgb(107, 216, 136);
       z-index: 2147483647;
       display: none;
       align-items: center;
       justify-content: center;
       padding: 24px;
     }
  
     /* When visible */
     #${OVERLAY_ID}[data-open="true"] { display: flex; }
  
     /* Backdrop blur (preferred) */
     #${OVERLAY_ID}::before {
       content: "";
       position: absolute;
       inset: 0;
       background: rgba(0,0,0,0.25);
       backdrop-filter: blur(var(--blur-overlay-amount, 8px)) brightness(0.95);
       -webkit-backdrop-filter: blur(var(--blur-overlay-amount, 8px)) brightness(0.95);
     }
  
     /* Message card */
     #${OVERLAY_ID} .blur-msg {
       position: relative;
       max-width: min(720px, 90vw);
       width: max(320px, 40vw);
       background: rgba(255,255,255,0.9);
       border-radius: 16px;
       box-shadow: 0 10px 30px rgba(0,0,0,0.2);
       padding: 20px 24px;
       font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
       color: #111;
       backdrop-filter: blur(2px);
     }
  
     #${OVERLAY_ID} .blur-msg h2 {
       margin: 0 0 10px 0;
       font-size: 18px;
       font-weight: 600;
       color: var(--brand-color);
     }
  
     #${OVERLAY_ID} .blur-msg .blur-text {
       line-height: 1.5;
       font-size: 15px;
       white-space: pre-wrap;
     }
  
     /* Close (X) in top-right of viewport */
     #${OVERLAY_ID} .blur-close {
       position: fixed;
       top: 12px;
       right: 12px;
       appearance: none;
       border: none;
       background: var(--brand-color);
       color: #fff;
       width: 36px;
       height: 36px;
       border-radius: 10px;
       font-size: 20px;
       line-height: 36px;
       text-align: center;
       cursor: pointer;
       box-shadow: 0 4px 12px rgba(0,0,0,0.25);
     }
     #${OVERLAY_ID} .blur-close:hover { background: #00937f; }
     #${OVERLAY_ID} .blur-close:focus { outline: 2px solid #fff; outline-offset: 2px; }
   `;
  document.head.appendChild(style);
}

function createOverlay() {
  if (document.getElementById(OVERLAY_ID)) {
    overlayEl = document.getElementById(OVERLAY_ID);
    msgEl = overlayEl.querySelector('.blur-text');
    closeBtn = overlayEl.querySelector('.blur-close');
    return;
  }
  overlayEl = document.createElement('div');
  overlayEl.id = OVERLAY_ID;
  overlayEl.setAttribute('aria-hidden', 'true');

  const card = document.createElement('div');
  card.className = 'blur-msg';
  card.setAttribute('role', 'dialog');
  card.setAttribute('aria-modal', 'true');
  card.setAttribute('aria-live', 'polite');

  const title = document.createElement('h2');
  title.textContent = 'Notice';

  msgEl = document.createElement('div');
  msgEl.className = 'blur-text';
  msgEl.textContent = '';

  closeBtn = document.createElement('button');
  closeBtn.className = 'blur-close';
  closeBtn.setAttribute('type', 'button');
  closeBtn.setAttribute('aria-label', 'Close overlay');
  closeBtn.textContent = '×';

  card.appendChild(title);
  card.appendChild(msgEl);

  overlayEl.appendChild(card);
  overlayEl.appendChild(closeBtn);
  document.body.appendChild(overlayEl);

  closeBtn.addEventListener('click', hide);
  document.addEventListener('keydown', (e) => {
    // Only a real keypress closes it; the injector's own synthetic Escape
    // (used to dismiss Prompt popups) must not drop the blur mid-scan.
    if (overlayEl.dataset.open === 'true' && e.key === 'Escape' && e.isTrusted) hide();
  });

  // If user clicks the dim area (not the card), do nothing (X/ESC only)
  overlayEl.addEventListener('click', (e) => {
    const clickedInsideCard = e.target === card || card.contains(e.target);
    const clickedClose = e.target === closeBtn;
    if (!clickedInsideCard && !clickedClose) {
      // no-op; keep modal open unless using X/ESC
    }
  });
}

function ensureSupport() {
  usingBackdrop =
    typeof CSS !== 'undefined' &&
    (CSS.supports('backdrop-filter: blur(8px)') ||
      CSS.supports('-webkit-backdrop-filter: blur(8px)'));
}

function show(message = '', opts: Record<string, any> = {}) {
  injectStyles();
  createOverlay();
  ensureSupport();

  // Options
  const {
    title = 'Notice',
    blurAmount = 8,
    textColor,
    background,
    width // e.g. '600px' or '50vw'
  } = opts;

  // Apply styles via CSS vars and inline as needed
  overlayEl.style.setProperty('--blur-overlay-amount', String(blurAmount));
  const card = overlayEl.querySelector('.blur-msg');
  if (textColor) card.style.color = textColor;
  if (background) card.style.background = background;
  if (width) card.style.width = width;

  overlayEl.querySelector('h2').textContent = title;
  msgEl.textContent = message ?? '';

  // Toggle classes depending on support
  document.documentElement.classList.add(ACTIVE_CLASS);
  document.body.classList.add(ACTIVE_CLASS);

  if (!usingBackdrop) {
    // Fallback: blur page content via CSS filter on everything but the overlay
    // Already handled by the CSS rule when ACTIVE_CLASS is present.
  }

  // Control visibility of close button (always visible with current UX)
  closeBtn.style.display = '';

  // Open
  overlayEl.dataset.open = 'true';
  overlayEl.setAttribute('aria-hidden', 'false');

  // Focus management
  lastFocused =
    document.activeElement instanceof HTMLElement
      ? document.activeElement
      : null;
  closeBtn.focus();

  return true;
}

function update(message = '') {
  if (!overlayEl) createOverlay();
  msgEl.textContent = message ?? '';
  return true;
}

function hide() {
  if (!overlayEl) return false;

  overlayEl.dataset.open = 'false';
  overlayEl.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove(ACTIVE_CLASS);
  document.body.classList.remove(ACTIVE_CLASS);

  // Restore focus
  if (lastFocused && document.contains(lastFocused)) {
    try {
      lastFocused.focus();
    } catch {}
  }
  lastFocused = null;
  return true;
}

function isVisible() {
  return !!(overlayEl && overlayEl.dataset.open === 'true');
}

// // Public API -> Not used globally, only used in this file...
// window.BlurOverlay = { show, update, hide, isVisible };
/* End the Blur Overlay */

/* Overlay ref-count helpers to avoid cross-call hide races */
let __overlayRefCount = 0;

function beginOverlay(message: string, opts?: Record<string, any>) {
  __overlayRefCount++;
  if (!isVisible()) {
    show(message, opts);
  } else {
    update(message);
  }
  return __overlayRefCount;
}

function endOverlay() {
  __overlayRefCount = Math.max(0, __overlayRefCount - 1);
  if (__overlayRefCount === 0 && isVisible()) {
    hide();
  }
}

// Queue tracking for per-question answering overlay messaging
let __overlayAnswerQueue = [];
function formatAnswerQueueMessage() {
  const total = __overlayAnswerQueue.length;
  const header = 'Finishing your note… This should only take a few seconds.';
  if (total === 0) return header;

  const current = __overlayAnswerQueue[0];
  const nextItems = __overlayAnswerQueue.slice(1);
  const nextPreview = nextItems.slice(0, 3);
  const remaining = Math.max(0, nextItems.length - nextPreview.length);

  let message = header + `\nCurrently working on: ${current}`;
  if (nextPreview.length > 0) {
    const list = nextPreview.join(', ');
    message +=
      `\nUp next: ${list}` + (remaining > 0 ? `, and ${remaining} more` : '');
  }
  return message;
}
function pushQuestionToQueue(questionLabel) {
  if (!questionLabel) return;
  if (!__overlayAnswerQueue.includes(questionLabel)) {
    __overlayAnswerQueue.push(questionLabel);
  }
  if (isVisible()) update(formatAnswerQueueMessage());
}
function removeQuestionFromQueue(questionLabel) {
  const idx = __overlayAnswerQueue.indexOf(questionLabel);
  if (idx !== -1) __overlayAnswerQueue.splice(idx, 1);
  if (isVisible()) update(formatAnswerQueueMessage());
  // Hold the cache another 10s: the queue empties between answers and a
  // rescrape now would clobber fills still in flight.
  lastGetQuestionsAt = Date.now();
}

export async function getPageInfo() {
  /*
    Description: This function will get the page info from the note
    Return: A dictionary with the page info
        {
      "URL": Base URL for the page,
      "Note Type": "PT Daily/SOAP Note",...
    }
    */

  const baseURL = window.location.origin;
  // Rather than hardcode to Prompt Note, be more dynamic

  // The visit dropdown button's first line reads "Wed, 8/19 - Visit 1 - Follow
  // Up"; the last dash-separated part is the visit type. Read it from the
  // button rather than opening its menu: the menu only exists in the DOM while
  // open, and opening it flashed on screen every time this ran.
  let noteType = 'Prompt Note';
  try {
    const dropdown = document.querySelector(
      'button.q-btn-dropdown .q-btn__content .column > div'
    );
    const parts = (dropdown?.textContent || '').split(' - ');
    const visitType = parts.length > 1 ? parts[parts.length - 1].trim() : '';
    if (visitType) noteType = visitType;
  } catch (e) {
    console.error('Error getting the note type');
    getLogFromInjector();
  }

  return {
    URL: baseURL,
    'Note Type': noteType
  };
}
// function getPatientInfo(){
export async function getPatientInfo() {
  beginOverlay('Reading patient details… This won’t take long.', { title: 'ComprehendPT' });
  try {
    return await getPatientInfoInner();
  } finally {
    endOverlay();
    await closeStrayOverlays();
  }
}

async function getPatientInfoInner() {
  /*
        Description: This function will get the patient info from the note
        Return: A dictionary with the patient info
    {
      "EMR ID": 0x1234 or "michalskij"
      "First Name":firstName,
      "Last Name": lastName,
      "DOB": dob,
    }
        */
  // name=ctl00_cp1_patientFirst
  // use the query selector to get the patient info
  try {
    let fullNameNeighborLS = document.querySelectorAll('.p-text-caption');
    let fullNameElement;
    for (let i = 0; i < fullNameNeighborLS.length; i++) {
      if (fullNameNeighborLS[i].textContent.trim() == 'Patient') {
        fullNameElement = fullNameNeighborLS[i].parentElement.children[1];
        break;
      }
    }

    if (!fullNameElement) {
      console.error('Full Name Element not found');
      return null;
    }

    const fullName = fullNameElement.textContent.trim();
    const res = getFirstAndLastName(fullName);
    const firstName = res['firstName'];
    const lastName = res['lastName'];
    const dob = '05/29/2023';
    const emrID = fullNameElement.nextElementSibling.textContent
      .replace('Acct#:', '')
      .trim();
    // Fetch additional content and metadata
    const metadata = await fetchMetadata();
    return {
      'EMR ID': emrID,
      'First Name': firstName,
      'Last Name': lastName,
      DOB: dob,
      Metadata: metadata
    };
  } catch (e) {
    console.error(`Error getting the patient info ${e}`);
    return null;
  }
}

function getFirstAndLastName(fullName) {
  // Define a regular expression to match the first name, optional nickname, and last name
  const nameRegex = /^(\w+)\s*(?:"(\w+)")?\s+(\w+)$/;
  const match = fullName.match(nameRegex);

  if (match) {
    const firstName = match[1];
    const nickname = match[2];
    const lastName = match[3];

    // If there's a nickname, include it in the first name
    const finalFirstName = nickname ? `${firstName} "${nickname}"` : firstName;

    return {
      firstName: finalFirstName,
      lastName: lastName
    };
  } else {
    return {
      firstName: fullName,
      lastName: ''
    };
  }
}

// Function to fetch metadata
async function fetchMetadata() {
  try {
    // Process all icons to fetch content
    let additionalContent = await processIcons();

    // Extract data from all sections
    const sectionData = await clickIntakeAndExtractData();
    await closeStrayOverlays();

    // Collect and format metadata
    let metadata = '';
    metadata += `${additionalContent}\n`;

    if (sectionData) {
      for (const [section, data] of Object.entries(sectionData)) {
        let sectionContentAdded = false;

        // Check if there is any text field or checkbox to add
        if (data.textFields.length > 0 || data.checkboxes.length > 0) {
          metadata += `\n${section}:`;

          data.textFields.forEach((field) => {
            if (field.label && field.answer) {
              metadata += `\n- ${field.label}: ${field.answer}`;
              sectionContentAdded = true;
            }
          });

          // Only add checkboxes if no text fields were added
          if (data.checkboxes.length > 0 && !sectionContentAdded) {
            metadata += ` ${data.checkboxes.join(', ')}\n`;
          }

          if (sectionContentAdded) {
            metadata += '\n'; // Add a newline after the section content
          }
        }
      }
    }
    // Replace all instances of "Generate Ledger" with an empty string
    metadata = metadata.replace(/Generate Ledger/g, '');
    // Split the string into lines
    let lines = metadata.split('\n');

    // Process each line to remove extra spaces
    lines = lines.map((line) => line.trim().replace(/\s+/g, ' '));

    // Join the lines back together
    metadata = lines.join(' ');
    return metadata;
  } catch (e) {
    console.error(`Error fetching metadata: ${e}`);
    return 'Metadata could not be fetched.';
  }
}

/* ------------------------------------------------------------------------ *
 * Popups opened while reading patient info (ledger menu, Intake dialog) must
 * be closed again, and the close has to be verified: a hidden-but-open Quasar
 * overlay comes back on the next toggle and stays on screen.
 * ------------------------------------------------------------------------ */

function isShown(el: Element | null): el is HTMLElement {
  return (
    !!el &&
    el.isConnected &&
    getComputedStyle(el).display !== 'none' &&
    getComputedStyle(el).visibility !== 'hidden'
  );
}

function openMenus(): HTMLElement[] {
  return Array.from(document.querySelectorAll('.q-menu')).filter(isShown) as HTMLElement[];
}

function openIntakeDialog(): HTMLElement | null {
  const title = Array.from(document.querySelectorAll('.q-dialog .text-h6')).find(
    (el) => /intake details/i.test(el.textContent || '')
  );
  const dialog = title?.closest('.q-dialog') as HTMLElement | null;
  return dialog && isShown(dialog) ? dialog : null;
}

function pressEscape() {
  const init = { key: 'Escape', code: 'Escape', keyCode: 27, which: 27, bubbles: true };
  (document.activeElement || document.body).dispatchEvent(new KeyboardEvent('keydown', init));
  document.dispatchEvent(new KeyboardEvent('keydown', init));
  (document.activeElement || document.body).dispatchEvent(new KeyboardEvent('keyup', init));
}

/** Try the overlay's own close action, then Escape, until it is really gone. */
async function closeOverlay(
  isOpen: () => HTMLElement | null,
  close: () => void,
  label: string
): Promise<boolean> {
  for (let attempt = 0; attempt < 6; attempt++) {
    if (!isOpen()) return true;
    if (attempt % 2 === 0) close();
    else pressEscape();
    await sleep(200);
  }
  const left = isOpen();
  if (!left) return true;
  console.warn(`[Prompt] ${label} would not close; hiding it`);
  left.style.display = 'none';
  return false;
}

/** Anything still open after a scan: ledger menus, the Intake dialog. */
async function closeStrayOverlays() {
  for (const menu of openMenus()) {
    await closeOverlay(() => (isShown(menu) ? menu : null), pressEscape, 'menu');
  }
  const dialog = openIntakeDialog();
  if (dialog) {
    await closeOverlay(
      openIntakeDialog,
      () => (findCloseButton(dialog) || { click: pressEscape }).click(),
      'Intake dialog'
    );
  }
}

function findCloseButton(container: Element): HTMLElement | null {
  const icon = Array.from(container.querySelectorAll('button i')).find(
    (i) => i.textContent?.trim() === 'close'
  );
  return (icon?.closest('button') as HTMLElement | null) || null;
}

// Open the patient ledger menu behind a folder_shared icon, read it, close it.
async function clickAndLogContent(icon) {
  let additionalContent = '';
  if (icon.textContent.trim() !== 'folder_shared') return '';

  const before = new Set(openMenus());
  icon.click();
  let menu: HTMLElement | null = null;
  for (let i = 0; i < 20 && !menu; i++) {
    await sleep(100);
    menu = openMenus().find((m) => !before.has(m)) || null;
  }
  if (!menu) {
    console.error('Patient Ledger menu not found');
    return '';
  }

  const content = menu.innerText.trim();
  if (content) additionalContent += content;

  const target = menu;
  await closeOverlay(
    () => (isShown(target) ? target : null),
    () => icon.click(),
    'Patient Ledger menu'
  );
  return additionalContent;
}

// Function to process all icons
async function processIcons() {
  // Find all <i> elements with the specified class names
  const icons = document.querySelectorAll(
    'i.q-icon.notranslate.material-icons'
  );
  let additionalContent = '';
  // Iterate through the elements
  for (const icon of icons) {
    const content = await clickAndLogContent(icon);
    additionalContent += content; // Accumulate content from all icons
  }
  return additionalContent;
}

// Function to click on the "Intake" element, extract section data, and then click "close" icon
async function clickIntakeAndExtractData() {
  try {
    // Find the "Intake" element
    const intakeSpan = Array.from(document.querySelectorAll('span')).find(
      (span) => span.textContent.trim() === 'Intake'
    );

    if (!intakeSpan) {
      console.error('Intake span element not found');
      return null;
    }

    // Click on the "Intake" element
    intakeSpan.click();

    // Wait for content to load or update (adjust the timeout as needed)
    // Wait for the q-card to appear
    const cardSelector = 'div.text-h6.text-p-gray600';
    const qCard = (await waitForElement(cardSelector))?.closest('.q-card');

    if (!qCard) {
      console.error('Intake Details not found');
      return null;
    }
    // Extract section data
    const sectionData = extractAllSectionsData();

    const dialog = (qCard.closest('.q-dialog') as HTMLElement | null) || qCard;
    await closeOverlay(
      () => (isShown(dialog) ? dialog : null),
      () => (findCloseButton(qCard) || { click: pressEscape }).click(),
      'Intake dialog'
    );

    return sectionData;
  } catch (e) {
    console.error(`Error clicking Intake and extracting data: ${e}`);
    return null;
  }
}
// Utility function to wait for an element to be visible
function waitForElement(selector, timeout = 2000) {
  return new Promise((resolve, reject) => {
    const interval = 100;
    const totalWait = timeout;
    let elapsedTime = 0;

    const checkVisibility = () => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
      } else {
        elapsedTime += interval;
        if (elapsedTime >= totalWait) {
          reject(new Error('Element not found within timeout'));
        } else {
          setTimeout(checkVisibility, interval);
        }
      }
    };

    checkVisibility();
  });
}
// Function to extract data from all sections, including checkboxes and text areas
function extractAllSectionsData() {
  // Select all section headers
  const headers = document.querySelectorAll(
    'div.text-h6.q-pt-md, div.text-subtitle1.q-mb-sm'
  );

  let currentSection = null;
  let sectionData = {};
  let sectionOrder = [];

  headers.forEach((header) => {
    const headerText = header.textContent.trim();

    // Initialize section data if it doesn't exist
    if (!sectionData[headerText]) {
      sectionData[headerText] = { textFields: [], checkboxes: [] };
      sectionOrder.push(headerText); // Maintain order of sections
    }
    currentSection = headerText;

    // Process sibling elements for text fields and checkboxes
    let sibling = header.nextElementSibling;
    while (
      sibling &&
      !sibling.matches('div.text-h6.q-pt-md, div.text-subtitle1.q-mb-sm')
    ) {
      // Extract text areas (both textarea and contenteditable divs)
      const textAreas = sibling.querySelectorAll('textarea');
      textAreas.forEach((textarea) => {
        const label = textarea.getAttribute('aria-label')?.trim();
        const value = getTextInputValue(textarea)?.trim();

        if (label && value) {
          sectionData[currentSection].textFields.push({ label, answer: value });
        }
      });

      // Also check for contenteditable divs
      const contentEditableDivs = sibling.querySelectorAll(
        'div[contenteditable="true"]'
      );
      contentEditableDivs.forEach((div) => {
        const label = div.getAttribute('aria-label')?.trim();
        const value = getTextInputValue(div)?.trim();

        if (label && value) {
          sectionData[currentSection].textFields.push({ label, answer: value });
        }
      });

      // Extract checkboxes
      const checkboxes = sibling.querySelectorAll('div[role="checkbox"]');
      checkboxes.forEach((checkbox) => {
        const label = checkbox
          .querySelector('.q-checkbox__label')
          ?.textContent?.trim();
        const ariaChecked = checkbox.getAttribute('aria-checked') === 'true';

        if (label && ariaChecked) {
          sectionData[currentSection].checkboxes.push(label);
        }
      });

      // Move to the next sibling
      sibling = sibling.nextElementSibling;
    }
  });

  // Return section data with the correct format
  return sectionData;
}

// Helper Functions
function getParentSubtitle(elem) {
  var parent = elem.parentElement;
  var subtitle;
  var depth = 0;
  while (parent) {
    subtitle = parent.querySelector('.text-subtitle1');
    if (subtitle) {
      return subtitle.textContent.trim();
    }
    parent = parent.parentElement;
    depth++;
  }
  return null;
}

function getChildSubtitle(elem) {
  // Post update selector
  var subtitle = elem.querySelector('.command-input-label')?.textContent.trim();
  if (subtitle) {
    return subtitle;
  }
  subtitle = elem.querySelector('.text-subtitle1')?.textContent.trim();
  if (subtitle) {
    return subtitle;
  }
  return null;
}

function eventFactory(eventType) {
  return new Event(eventType, {
    bubbles: true, // If you want the event to bubble up through the DOM
    cancelable: true // If you want the event to be cancelable
  });
}

function getSelector(elm) {
  // This function will return the selector for a given element
  if (elm.tagName === 'BODY') return 'BODY';
  const names = [];
  while (elm.parentElement && elm.tagName !== 'BODY') {
    if (elm.id) {
      names.unshift('#' + elm.getAttribute('id')); // getAttribute, because `elm.id` could also return a child element with name "id"
      break; // Because ID should be unique, no more is needed. Remove the break, if you always want a full path.
    } else {
      let c = 1,
        e = elm;
      for (; e.previousElementSibling; e = e.previousElementSibling, c++);
      names.unshift(elm.tagName + ':nth-child(' + c + ')');
    }
    elm = elm.parentElement;
  }
  return names.join('>');
}

function findTemplate(element) {
  // Select all elements that could potentially contain the text
  var allElements = element.querySelectorAll('div'); // Adjust the tag names according to your needs

  // Iterate through the elements to find the one with "Text Templates"
  var foundElement = null;
  allElements.forEach(function (element) {
    if (element.textContent.includes('Text Templates')) {
      foundElement = element;
      // You can break out of the loop here if you want, but JavaScript doesn't have a built-in break for forEach
    }
  });

  // Check if an element was found and handle it
  if (foundElement) {
    return foundElement;
  } else {
    return null;
  }
}

function focusClick(elem) {
  elem.dispatchEvent(eventFactory('focusin'));
  elem.dispatchEvent(eventFactory('click'));
}

function findElementOfTypeWithText(baseElement, elementType, elementText) {
  var allElements = baseElement.querySelectorAll(elementType); // Adjust the tag names according to your needs
  var foundElement = null;
  for (var i = 0; i < allElements.length; i++) {
    if (allElements[i].textContent.includes(elementText)) {
      foundElement = allElements[i];
      break;
    }
  }
  return foundElement;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function bubbleFocus(element: Element) {
  element.dispatchEvent(new FocusEvent('focusin', { bubbles: true, cancelable: true }));
}

function nativeInputFill(element: HTMLInputElement | HTMLTextAreaElement, value: string) {
  const proto = element.tagName === 'TEXTAREA'
    ? window.HTMLTextAreaElement.prototype
    : window.HTMLInputElement.prototype;
  const nativeSetter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
  if (nativeSetter) {
    nativeSetter.call(element, value);
  } else {
    element.value = value;
  }
  element.dispatchEvent(new InputEvent('input', { bubbles: true }));
  element.dispatchEvent(new Event('change', { bubbles: true }));
}

function blockFor(milliseconds) {
  // Bad Practice....
  const start = Date.now();
  let current = null;
  do {
    current = Date.now();
  } while (current - start < milliseconds);
}

function waitForElementToDisplay(selector, maxTime) {
  var time = 10; // 100ms between checks
  return new Promise((resolve, reject) => {
    let totalTime = 0;

    function searchElement() {
      if (document.querySelector(selector) != null) {
        resolve('Element found');
      } else if (totalTime >= maxTime) {
        reject('Element not found within the specified time');
      } else {
        setTimeout(() => {
          totalTime += time;
          searchElement();
        }, time);
      }
    }

    searchElement();
  });
}

function choiceClicker(cpt, choice) {
  // This is the question answering function
  cpt.dispatchEvent(eventFactory('focusin'));
  cpt.dispatchEvent(eventFactory('click'));

  return waitForElementToDisplay('[role="listbox"]', 2000).then(function () {
    console.log('List Box Opened in the question answering function');
    var lBox = document.querySelector('[role="listbox"]');
    var qChoicesElement = lBox.querySelectorAll('.q-item__section');
    var found = false;
    qChoicesElement.forEach((innerElement) => {
      // innerElement.click() // (Toggles so we have to check it first)
      var localChoice = innerElement.textContent
        .trim()
        .replaceAll('\n        ', '');
      if (localChoice == choice) {
        if (!innerElement.parentElement.classList.contains('q-item--active')) {
          console.log('Clicking Choice: ' + choice);
          innerElement.click(); // (Toggles so we have to check it first)
          found = true;
        } else {
          console.log('Choice was already clicked!');
          found = true;
        }
      }
    });
    cpt.dispatchEvent(eventFactory('click')); // close it down...
    return found;
  });
}

async function tryToClick(selector, retryCount) {
  /*
    Description: This function will try to click an element, if the conditional is true, it will click it
    Otherwise it will try again in .1 seconds

    Args:
        selector: function that clicks a button and returns true if it was clicked, false otherwise (in a promise)
        retryCount: The number of times to retry
    
    Return: a promise that resolved to true if the element was clicked, false otherwise

    */

  if (retryCount <= 0) {
    console.error('Retry Count exceeded, element was not clicked');
    return false;
  }

  await sleep(100);

  console.log('Trying Selector');
  let result = await selector();
  console.log('Selector result = ' + result);
  if (result) {
    console.log('Element was clicked');
    return true;
  }

  // Did not return true, try again
  console.error('Element was not clicked, trying again in .1 seconds');
  return sleep(10).then(() => {
    return tryToClick(selector, retryCount - 1);
  });
}

/** Current memo text: the editable div first, the hidden sync textarea second. */
function memoValue(memo: HTMLElement): string {
  const text = ((memo as any).innerText ?? memo.textContent ?? '').trim();
  if (text) return text;
  const hidden = memo.parentElement?.querySelector('textarea') as
    | HTMLTextAreaElement
    | null;
  return hidden?.value?.trim() ?? '';
}

/**
 * Fill a memo the way a user types: select-all + insertText, so Vue's input
 * listener fires for contenteditable="plaintext-only" as well as "true". Falls
 * back to setting the text and synthesizing the event; keeps the hidden
 * textarea in sync in case the component reads from it.
 */
function fillMemo(memo: HTMLElement, val: any, replyType?: string) {
  if (isEmptyOrNull(val)) return;
  const current = memoValue(memo);
  const text =
    replyType === 'append' && current ? `${current}\n${val}` : String(val);
  const squash = (s: string) => s.replace(/\s+/g, ' ').trim();

  bubbleFocus(memo);
  memo.focus();
  let ok = false;
  try {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(memo);
    selection?.removeAllRanges();
    selection?.addRange(range);
    // execCommand wraps each line in a <div>; Prompt reads each child's textContent and drops the line breaks.
    ok = !text.includes('\n') && document.execCommand('insertText', false, text);
  } catch (e) {
    ok = false;
  }
  if (!ok || squash(memo.textContent || '') !== squash(text)) {
    memo.textContent = text;
    memo.dispatchEvent(
      new InputEvent('input', { bubbles: true, inputType: 'insertText', data: text })
    );
  }
  const hidden = memo.parentElement?.querySelector('textarea') as
    | HTMLTextAreaElement
    | null;
  if (hidden && hidden.value !== text) nativeInputFill(hidden, text);
  memo.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
  memo.blur();
}

function getTextInputElement(container) {
  // Prompt memos are contenteditable divs ("true" once focused, "plaintext-only"
  // before) with a hidden sync textarea beside them; the div is the real input.
  let element = container.querySelector('div[contenteditable]');
  if (element) return element;

  // Try to find textarea (legacy) (Broken...)
  element = container.querySelector('textarea');
  return element;

  return null;
}

function getTextInputValue(input) {
  // Check if it's a textarea (has .value property)
  if (input.tagName === 'TEXTAREA') {
    return input.value;
  }
  // Check if it's a contenteditable div
  if (input.hasAttribute('contenteditable')) {
    let content = input.innerText || input.textContent || '';
    content = content.trim();

    // If contenteditable has content, use it (post-click state)
    if (content && content.length > 0) {
      return content;
    }
    // Capture records what the clinician wrote, never the prompt text.
    if (capturingValues) return content;

    // If contenteditable is empty, check for placeholder text (pre-click state)
    // The placeholder might be hidden (display: none) but still have text
    const qEditor = input.closest('.q-editor');
    if (qEditor && qEditor.parentElement) {
      // Look for placeholder sibling of q-editor (even if hidden)
      const siblings = Array.from(qEditor.parentElement.children);
      for (const sibling of siblings) {
        if (
          sibling instanceof HTMLElement &&
          sibling.classList.contains('placeholder')
        ) {
          const placeholderText =
            sibling.textContent || sibling.innerText || '';
          if (placeholderText.trim()) {
            return placeholderText.trim();
          }
        }
      }
    }

    // Also check inside the container (fallback)
    const container = input.closest(
      '.q-editor, .command-input-wrapper, .full-width, .relative-position, label'
    );
    if (container) {
      const placeholder = container.querySelector('.placeholder');
      if (placeholder instanceof HTMLElement) {
        const placeholderText =
          placeholder.textContent || placeholder.innerText || '';
        if (placeholderText.trim()) {
          return placeholderText.trim();
        }
      }
    }

    return content;
  }
  return '';
}

function setTextInputValue(input, val) {
  // Check if it's a textarea (has .value property)
  if (isEmptyOrNull(val)) {
    return;
  }
  if (input.tagName === 'TEXTAREA') {
    input.value = val;
  }
  // Check if it's a contenteditable div
  else if (input.getAttribute('contenteditable') === 'true') {
    // For contenteditable divs, we need to preserve the HTML structure
    // Clear existing content
    input.innerHTML = '';

    // Split the value by newlines and create proper HTML structure
    const lines = val.split('\n');
    lines.forEach((line, index) => {
      if (index > 0) {
        input.appendChild(document.createElement('div'));
        const lastDiv = input.lastChild;
        lastDiv.appendChild(document.createElement('br'));
      }
      if (line.trim() !== '') {
        const div = document.createElement('div');
        div.textContent = line;
        input.appendChild(div);
      }
    });

    // Dispatch input event to notify the app of the change
    input.dispatchEvent(
      new Event('input', { bubbles: true, cancelable: true })
    );
  }
}

function isEmptyOrNull(value) {
  return (
    value === null || value === undefined || value === '' || value === 'None'
  );
}

function textBoxUpdate(input, val, replyType) {
  // This function will update the text box with the given text
  if (isEmptyOrNull(val)) {
    return;
  }
  if (!input) {
    console.error('No input element found for textBoxUpdate');
    return;
  }
  if (input.hasAttribute && input.hasAttribute('contenteditable')) {
    fillMemo(input, val, replyType);
    return;
  }

  // Focus the element first (but don't click to avoid double clicks)
  if (input.focus) {
    input.focus();
  }

  // Only dispatch focus event, not click, to avoid double-clicking
  input.dispatchEvent(eventFactory('focus'));
  input.dispatchEvent(eventFactory('focusin'));
  input.dispatchEvent(eventFactory('compositionstart'));

  if (replyType == 'append') {
    const currentValue = getTextInputValue(input);
    setTextInputValue(input, currentValue + '\n' + val);
  } else {
    setTextInputValue(input, val);
  }

  input.dispatchEvent(eventFactory('compositionend'));
  input.dispatchEvent(eventFactory('input'));
  input.dispatchEvent(eventFactory('change'));
}

// This is where we will store the questions and interactions for populating the answers later
var questions = [];
var questionInteractions = {};
// Cache the computed questions to avoid expensive recomputation for rapid, back-to-back calls
var cachedQuestions = null;
var lastGetQuestionsAt = 0;

// var questionsLoaded = false;    // Switches to true when the questions are loaded
let resolveQuestionsLoaded;
const questionsLoadedPromise = new Promise((resolve) => {
  resolveQuestionsLoaded = resolve;
});


/* ------------------------------------------------------------------------ *
 * flex++ core
 *
 * A leaf carries only reserved keys (_existingValue/_choices/_multiple/_type/
 * _description); anything else is a branch. Numeric path segments build lists,
 * which the backend sizes (>= current length) off element 0 as the prototype.
 * ------------------------------------------------------------------------ */

const FLEXPP_TOGGLE_KEY = 'flex++';
const FLEXPP_MAX_DEPTH = 10;
const GOALS_KEY = 'Goals';
const FLEX_LEAF = '__leaf';

// SOAP stays as plain Long Answer questions (same as the legacy injector); the
// rest of the "Notes/Plan" container (Contraindications, Modalities, Prognosis,
// Patient Education...) is one nested flex++ question.
const SOAP_SECTIONS: Record<string, string> = {
  subjective: 'Subjective',
  objective: 'Objective',
  assessment: 'Assessment',
  plan: 'Plan'
};


// Quasar toggle groups include icon-only buttons (history, expand_more, ...).
// Their label is the material-icon ligature, never a real choice.
const ICON_LIGATURES = new Set([
  'history',
  'expand_more',
  'expand_less',
  'more_vert',
  'more_horiz',
  'close',
  'edit',
  'add',
  'remove',
  'search',
  'event',
  'visibility',
  'keyboard_arrow_down',
  'keyboard_arrow_up',
  'arrow_drop_down',
  'check_circle_outline',
  'layers',
  'archive',
  'delete'
]);

// The backend already maps these to null (GPTDialog.__cleanResponse); guard anyway.
const FLEX_SENTINELS = new Set(['not discussed', '-99999', '99999']);

type FlexPath = (string | number)[];

type FlexLeaf = {
  path: FlexPath;
  existing?: string | number | null;
  choices?: (string | number)[];
  multiple?: boolean;
  type?: 'string' | 'integer' | 'number';
  description?: string;
  // The ticked choices of a multi-choice leaf, for note capture.
  selected?: string[];
  input: (val: any, replyType?: string) => any;
};

type BranchHints = Record<
  string,
  { description?: string; noPrune?: boolean }
>;

type FillError = { Field: string; Error: string };

let flexLeaves: FlexLeaf[] = [];
let flexBranchHints: BranchHints = {};
let flexDocTree: Record<string, any> = {};
// Per-section fill trees, keyed by the question name the panel shows. 'wrapped'
// records whether that section's structure keeps its own name as its root key.
let flexSectionTrees: Record<string, { tree: any; wrapped: boolean }> = {};
let flexPathSeen = new Map<string, number>();
let flexHandled = new WeakSet<Element>();
// Two scrapers can reach the same widget (a SOAP memo is picked up by both
// topLevelShortAnswer and extractAllSectionComments). Dedupe on the element so
// the second pass is dropped instead of landing as "Subjective #2".
let flexRegisteredInputs = new WeakSet<Element>();
let sectionIdCache: Set<string> | null = null;

/*
Set only while readNoteForCapture runs the scrapers: they then never open,
click or wait for anything, record empty values instead of placeholder text,
and report what capture needs beyond the leaves.
*/
let capturingValues = false;
// Question key -> the section its field was found in (SOAP questions).
let captureOwners: Map<string, string> | null = null;
// Goal lists with no goals on screen.
let captureEmptyLists: FlexPath[] | null = null;
// Collapsed measurement cards: [section, card title] they would register under.
let captureCollapsedCards: FlexPath[] | null = null;

/** Punctuation becomes a space so "Side-Bending" and "Side Bending" match. */
function normalizeFlexKey(key: string): string {
  return String(key)
    .replace(/\(Last recorded.*?\)/gi, '')
    .replace(/[^\w\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

/** {"0": x, "1": y} -> [x, y]. The backend sends nested lists as indexed dicts. */
function normalizeIndexedDict(value: any): any {
  if (
    value === null ||
    typeof value !== 'object' ||
    Array.isArray(value) ||
    Object.keys(value).length === 0 ||
    !Object.keys(value).every((k) => /^\d+$/.test(k))
  ) {
    return value;
  }
  return Object.keys(value)
    .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
    .map((k) => value[k]);
}

function isBlankFlexValue(value: any): boolean {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') {
    const v = value.trim();
    return v === '' || FLEX_SENTINELS.has(v.toLowerCase());
  }
  if (typeof value === 'number') return FLEX_SENTINELS.has(String(value));
  return false;
}

/** Schema keys (_description, _choices, flex++...) the AI may echo back. */
function isFlexSchemaKey(key: string): boolean {
  return key.startsWith('_') || key === FLEXPP_TOGGLE_KEY;
}

/** True when a value carries no fillable content at any depth. */
function isEmptyFlexPayload(value: any): boolean {
  if (isBlankFlexValue(value)) return true;
  if (Array.isArray(value)) return value.every(isEmptyFlexPayload);
  if (typeof value === 'object')
    return Object.entries(value).every(
      ([k, v]) => isFlexSchemaKey(k) || isEmptyFlexPayload(v)
    );
  return false;
}

function flexEnsureContainer(
  parent: any,
  key: string | number,
  childIsList: boolean
) {
  const existing = parent[key as any];
  if (existing !== undefined && existing !== null) return existing;
  parent[key as any] = childIsList ? [] : {};
  return parent[key as any];
}

function flexSetAtPath(root: any, path: FlexPath, value: any) {
  let node = root;
  for (let i = 0; i < path.length - 1; i++) {
    node = flexEnsureContainer(node, path[i], typeof path[i + 1] === 'number');
  }
  node[path[path.length - 1] as any] = value;
}

function flexLeafToSchema(leaf: FlexLeaf): Record<string, any> {
  const node: Record<string, any> = {};
  if (!isBlankFlexValue(leaf.existing)) node._existingValue = leaf.existing;
  if (leaf.choices && leaf.choices.length > 0) node._choices = leaf.choices;
  if (leaf.multiple && leaf.choices && leaf.choices.length > 0)
    node._multiple = true;
  if (leaf.type && leaf.type !== 'string') node._type = leaf.type;
  if (leaf.description) node._description = leaf.description;
  // A leaf needs at least one reserved key or the backend reads it as a branch.
  if (Object.keys(node).length === 0) node._type = 'string';
  return node;
}

/** Data-only structure for the backend. */
function buildFlexStructure(
  leaves: FlexLeaf[],
  branchHints: BranchHints = {},
  opts: { pruneEarly?: boolean } = {}
): Record<string, any> {
  const root: Record<string, any> = {};

  for (const leaf of leaves) {
    if (!leaf.path || leaf.path.length === 0) continue;
    if (leaf.path.length > FLEXPP_MAX_DEPTH) {
      console.warn('[Prompt] flex++ path too deep, skipped:', leaf.path);
      continue;
    }
    flexSetAtPath(root, leaf.path, flexLeafToSchema(leaf));
  }

  for (const [joined, hint] of Object.entries(branchHints)) {
    const path = joined
      .split('/')
      .map((seg) => (/^\d+$/.test(seg) ? parseInt(seg, 10) : seg));
    let node: any = root;
    for (const seg of path) {
      node = node?.[seg as any];
      if (!node) break;
    }
    if (!node || typeof node !== 'object' || Array.isArray(node)) continue;
    if (hint.description) node._description = hint.description;
    if (hint.noPrune) node._no_prune = true;
  }

  root[FLEXPP_TOGGLE_KEY] = true;
  if (opts.pruneEarly) root['prune_early'] = true;
  return root;
}

/** Mirror of the structure holding the live fill closures. */
function buildInteractionTree(leaves: FlexLeaf[]): Record<string, any> {
  const root: Record<string, any> = {};
  for (const leaf of leaves) {
    if (!leaf.path || leaf.path.length === 0) continue;
    flexSetAtPath(root, leaf.path, {
      [FLEX_LEAF]: true,
      input: leaf.input,
      choices: leaf.choices,
      multiple: leaf.multiple
    });
  }
  return root;
}

function flexLookupChild(node: any, key: string): any {
  if (node === null || typeof node !== 'object') return undefined;
  if (key in node) return node[key];
  const target = normalizeFlexKey(key);
  for (const candidate of Object.keys(node)) {
    if (normalizeFlexKey(candidate) === target) return node[candidate];
  }
  return undefined;
}

/**
 * Walk the AI answer against the interaction tree and fire each leaf's input.
 * Returns per-field errors; never throws.
 */
async function fillFlexAnswer(
  tree: any,
  answer: any,
  replyType = 'overwrite'
): Promise<FillError[]> {
  const errors: FillError[] = [];

  const walk = async (node: any, rawValue: any, path: string[]) => {
    const field = path.join('.') || '(root)';
    const value = normalizeIndexedDict(rawValue);

    if (node === undefined || node === null) {
      if (!isEmptyFlexPayload(value)) {
        errors.push({
          Field: field,
          Error: 'No matching field in the document'
        });
      }
      return;
    }

    if (node[FLEX_LEAF]) {
      const values = Array.isArray(value) ? value : [value];
      const apply = async (val: any) => {
        try {
          await node.input(val, replyType);
          await sleep(50);
          (document.activeElement as HTMLElement)?.blur();
        } catch (e) {
          errors.push({ Field: field, Error: `Error applying value: ${e}` });
        }
      };
      if (node.multiple) {
        const list = values.filter((v) => !isEmptyFlexPayload(v));
        if (list.length > 0) await apply(list);
        return;
      }
      for (const v of values) {
        if (isEmptyFlexPayload(v)) continue;
        await apply(typeof v === 'object' ? JSON.stringify(v) : String(v));
      }
      return;
    }

    if (Array.isArray(node)) {
      const rows = Array.isArray(value) ? value : [value];
      for (let i = 0; i < rows.length; i++) {
        if (i >= node.length) {
          if (!isEmptyFlexPayload(rows[i])) {
            errors.push({
              Field: `${field}[${i}]`,
              Error: 'No row available to fill'
            });
          }
          continue;
        }
        await walk(node[i], rows[i], [...path, String(i)]);
      }
      return;
    }

    if (value === null || typeof value !== 'object') {
      // The AI flattened a single-child branch and answered it directly.
      const keys = Object.keys(node);
      if (keys.length === 1) {
        await walk(node[keys[0]], value, [...path, keys[0]]);
        return;
      }
      if (!isBlankFlexValue(value)) {
        errors.push({ Field: field, Error: 'Expected an object of sub-fields' });
      }
      return;
    }

    for (const [key, sub] of Object.entries(value)) {
      if (isFlexSchemaKey(key)) continue;
      await walk(flexLookupChild(node, key), sub, [...path, key]);
    }
  };

  await walk(tree, answer, []);
  return errors;
}

/** Row count the AI returned for a list path, so we can add DOM rows first. */
function requestedRowCount(answer: any, path: string[]): number {
  let node: any = answer;
  for (const seg of path) {
    node =
      node && typeof node === 'object' ? flexLookupChild(node, seg) : undefined;
    if (node === undefined) return 0;
  }
  const list = normalizeIndexedDict(node);
  if (!Array.isArray(list)) return 0;
  // Blank trailing rows (e.g. the echoed prototype) must not add goal boxes.
  let count = list.length;
  while (count > 0 && isEmptyFlexPayload(list[count - 1])) count--;
  return count;
}

/* ------------------------------------------------------------------------ *
 * Document scan helpers
 * ------------------------------------------------------------------------ */

/** Section ids come from the document's own anchor rail. */
function promptSectionIds(): Set<string> {
  const ids = new Set<string>();
  document.querySelectorAll('[anchor-key]').forEach((a) => {
    const key = a.getAttribute('anchor-key')?.trim();
    if (key) ids.add(key);
  });
  return ids;
}

function sectionOf(elem: Element | null): string {
  if (!sectionIdCache || sectionIdCache.size === 0)
    sectionIdCache = promptSectionIds();
  let node: Element | null = elem;
  while (node) {
    const id = node.id?.trim();
    if (id && sectionIdCache.has(id)) return id;
    node = node.parentElement;
  }
  return 'General';
}

function isFlexHandled(elem: Element | null) {
  let node: Element | null = elem;
  while (node) {
    if (flexHandled.has(node)) return true;
    node = node.parentElement;
  }
  // A container that wraps a goal card only holds that card's fields.
  return elem
    ? Array.from(elem.querySelectorAll('.q-card')).some((c) =>
        flexHandled.has(c)
      )
    : false;
}

function registerFlexLeaf(leaf: FlexLeaf) {
  if (!leaf.path.length || typeof leaf.input !== 'function') return;
  const joined = leaf.path.join('/');
  const seen = (flexPathSeen.get(joined) ?? 0) + 1;
  flexPathSeen.set(joined, seen);
  if (seen > 1) {
    const path = [...leaf.path];
    path[path.length - 1] = `${path[path.length - 1]} #${seen}`;
    leaf = { ...leaf, path };
  }
  flexLeaves.push(leaf);
}

/**
 * Register a scraped field as a flex++ leaf. SOAP fields become top-level keys;
 * everything else nests under the section it was scraped from.
 *
 * dedupeOn: the widget being filled, so a field reached by two scrapers is only
 * registered once.
 */
function registerFieldLeaf(
  elem: Element | null,
  label: string,
  leaf: Omit<FlexLeaf, 'path'>,
  dedupeOn?: Element | null
) {
  if (!label || isFlexHandled(elem)) return;
  if (dedupeOn) {
    if (flexRegisteredInputs.has(dedupeOn)) return;
    flexRegisteredInputs.add(dedupeOn);
  }
  if (SOAP_SECTIONS[normalizeFlexKey(label)]) return;
  registerFlexLeaf({ ...leaf, path: [sectionOf(elem), label] });
}

/** The legacy Long Answer entries for Subjective / Objective / Assessment / Plan. */
function soapQuestions() {
  const byName: Record<string, any> = {};
  for (const q of questions) {
    const name = SOAP_SECTIONS[normalizeFlexKey(q?.Question || '')];
    if (!name || q.Type !== 'Long Answer' || byName[name]) continue;
    if (q.Question !== name) {
      questionInteractions[name] = questionInteractions[q.Question];
    }
    byName[name] = { ...q, Question: name, Key: name };
  }
  return Object.values(SOAP_SECTIONS)
    .map((name) => byName[name])
    .filter(Boolean);
}

/**
 * Quasar renders the active label plus a zero-height clone of every choice, so
 * textContent on .q-btn__content concatenates them all. Mirror the scrapers.
 */
function choiceButtonText(btn: Element | undefined) {
  if (!btn) return undefined;
  const content = btn.querySelector('.q-btn__content') as any;
  const nested = content?.firstChild?.firstChild?.textContent?.trim();
  if (nested) return nested;
  const block = btn.querySelector('.block')?.textContent?.trim();
  return block || content?.textContent?.trim();
}

/** Icon-only button: its visible text is the material-icon ligature itself. */
function isIconButton(btn: Element) {
  const icon = btn.querySelector('i.q-icon, i.material-icons, i[class*="mdi-"]');
  if (!icon) return false;
  const text = choiceButtonText(btn);
  if (!text) return true;
  return (
    text === icon.textContent?.trim() ||
    ICON_LIGATURES.has(text.toLowerCase())
  );
}

/** Real choices only: no icon ligatures, no glyph-only toggles (a lone tick). */
function usableChoices(
  buttons: Element[],
  interaction: Record<string, any>
): string[] {
  const choices = buttons
    .filter((b) => !isIconButton(b))
    .map((b) => choiceButtonText(b))
    .filter((t): t is string => !!t && typeof interaction[t] === 'function');
  const unique = Array.from(new Set(choices));
  // A group whose only option is a glyph (the "✔" education acknowledgement)
  // is an acknowledgement, not a decision - nothing for the AI to answer.
  return unique.some((c) => /[a-z0-9]/i.test(c)) ? unique : [];
}

function stripRecordedSuffix(label: string) {
  return label.replace(/\(Last recorded.*?\)/, '').trim();
}

function activeChoiceText(buttons: Element[], activeClass: string) {
  return choiceButtonText(
    buttons.find((b) => b.classList.contains(activeClass))
  );
}

/** Fire a scraped click closure for an AI choice, tolerating punctuation drift. */
function clickChoice(interaction: Record<string, any>, val: string) {
  const direct = interaction[val];
  if (typeof direct === 'function') return direct();
  const match = Object.keys(interaction).find(
    (c) => normalizeFlexKey(c) === normalizeFlexKey(String(val))
  );
  if (match && typeof interaction[match] === 'function')
    return interaction[match]();
  throw new Error(`Choice "${val}" not found`);
}

/**
 * Multi-select fills must be sequential: Quasar checkboxes compute the new
 * array from the model they were last rendered with, so a burst of synchronous
 * clicks all start from the same stale array and only the last one survives.
 * Re-resolve each box by label in case the click re-rendered the grid.
 */
async function checkChoices(
  container: Element | null,
  interaction: Record<string, any>,
  vals: any,
  label: string
) {
  for (const v of Array.isArray(vals) ? vals : [vals]) {
    const text = String(v);
    try {
      const fresh = container
        ? Array.from(container.querySelectorAll('.q-checkbox')).find(
            (box) =>
              normalizeFlexKey(box.getAttribute('aria-label') || box.textContent || '') ===
              normalizeFlexKey(text)
          )
        : undefined;
      const inner = fresh?.querySelector('.q-checkbox__inner');
      if (inner) {
        if (!inner.classList.contains('q-checkbox__inner--truthy'))
          (inner as HTMLElement).click();
      } else {
        clickChoice(interaction, text);
      }
    } catch (e) {
      console.warn(`[Prompt] ${label}: ${e}`);
    }
    await sleep(150);
  }
}

function isGoalCard(card: Element) {
  return Array.from(card.querySelectorAll('.q-field__label')).some(
    (l) => normalizeFlexKey(l.textContent || '') === 'goal description'
  );
}

const GOAL_TERMS = ['Long', 'Short'];
const GOAL_DURATION_UNITS = ['Weeks', 'Months'];
const GOAL_TYPES = ['Outcomes', 'Function', 'General Tests', 'Pain', 'ROM', 'Special Tests', 'Strength'];
// Goal rows actually on screen, per section. The list the AI sees ends in a
// prototype row, so ensureGoalRows counts from here instead of the list length.
let goalRowCounts: Record<string, number> = {};
// All Goals cards in leaf order, so ensureGoalRows can spot the ones it added.
let goalCards: Element[] = [];

/** Top-level Goals keeps its own name as the root key; sections nest under theirs. */
function goalPath(section: string, index: number): FlexPath {
  return section === GOALS_KEY
    ? [GOALS_KEY, index]
    : [section, GOALS_KEY, index];
}

/** A card prints its own settings above the fields: "Goal term: Long". */
function goalMetaValue(card: Element, label: string): string | null {
  const row = card.querySelector(':scope > .row');
  const target = normalizeFlexKey(label);
  for (const cell of Array.from(row?.children || [])) {
    const own =
      ownText(cell) ||
      ownText(cell.firstElementChild) ||
      cell.querySelector('span:not(.text-weight-medium)')?.textContent ||
      '';
    if (normalizeFlexKey(own) !== target) continue;
    const value = cell
      .querySelector('.text-weight-medium')
      ?.textContent?.trim();
    return value && value !== '-' ? value : null;
  }
  return null;
}

/** Quasar q-select: open it, click the option, make sure the menu closed again. */
async function pickSelectOption(field: Element, value: string) {
  const control = field.querySelector('.q-field__control') as HTMLElement | null;
  if (!control) throw new Error('no select control');
  const menuId = field
    .querySelector('input.q-select__focus-target')
    ?.getAttribute('aria-controls');
  control.click();
  let menu: HTMLElement | null = null;
  for (let i = 0; i < 20 && !menu; i++) {
    await sleep(100);
    const byId = menuId ? document.getElementById(menuId) : null;
    const candidate = (byId && isShown(byId) ? byId : openMenus()[0]) || null;
    if (candidate?.querySelector('.q-item')) menu = candidate;
  }
  if (!menu) throw new Error('option list did not open');
  // Exact text first: ">12" and "12" normalize to the same key.
  const findMatch = () => {
    const items = Array.from(menu!.querySelectorAll('.q-item'));
    return (
      items.find((o) => (o.textContent || '').trim() === value.trim()) ||
      items.find((o) => normalizeFlexKey(o.textContent || '') === normalizeFlexKey(value))
    );
  };
  // Long lists only render what's scrolled into view; narrow with their search box.
  const search = menu.querySelector('input') as HTMLInputElement | null;
  if (!findMatch() && search) {
    nativeInputFill(search, value);
    await sleep(300);
  }
  const options = Array.from(menu.querySelectorAll('.q-item'));
  const match = findMatch();
  if (!match) {
    pressEscape();
    throw new Error(
      `"${value}" is not an option (${options
        .map((o) => o.textContent?.trim())
        .join(', ')})`
    );
  }
  (match as HTMLElement).click();
  await sleep(150);
  if (isShown(menu)) pressEscape();
}

function goalPrototypeDescription(section: string): string {
  const scope =
    section === GOALS_KEY
      ? 'a new goal for this plan of care'
      : `a new ${section} goal, written from the ${section} perspective and based on this section's findings`;
  return (
    `Leave blank unless you are adding a goal. Filling this in creates ${scope}. ` +
    'One list entry per goal: entries that already carry a goal description are ' +
    'goals on the note, and every entry past those adds a brand new goal row.'
  );
}

/**
 * One goal row. `card` is null for the prototype row - the shape the AI fills to
 * ask for a goal that isn't on the note yet; ensureGoalRows creates the row by
 * clicking "+ Goal" once per entry the AI returned.
 */
function registerGoalLeaves(
  path: FlexPath,
  card: Element | null,
  section: string
) {
  const missing = () => {
    throw new Error('goal row was not created');
  };
  if (card && !getTextInputElement(card)) return;

  registerFlexLeaf({
    path: [...path, 'Goal Description'],
    existing: card
      ? getExistingNote(getTextInputValue(getTextInputElement(card)))
      : null,
    description: card ? undefined : goalPrototypeDescription(section),
    input: card
      ? (val, replyType) =>
          textBoxUpdate(getTextInputElement(card), val, replyType)
      : missing
  });

  const termButtons = card
    ? Array.from(card.querySelectorAll('.horizontalButtonGroup button'))
    : [];
  const termLabels = termButtons
    .map((b) => choiceButtonText(b))
    .filter((t): t is string => !!t);
  registerFlexLeaf({
    path: [...path, 'Goal Term'],
    choices: termLabels.length > 0 ? termLabels : GOAL_TERMS,
    existing: card ? goalMetaValue(card, 'Goal term') : null,
    input: card
      ? (val) => {
          const target = normalizeFlexKey(String(val));
          const btn = termButtons.find(
            (b) => normalizeFlexKey(choiceButtonText(b) || '') === target
          );
          if (!btn) throw new Error(`Choice "${val}" not found`);
          const now = goalMetaValue(card, 'Goal term');
          if (now && normalizeFlexKey(now) === target) return;
          (btn as HTMLElement).click();
        }
      : missing
  });

  const durationField = card?.querySelector('.goal-duration-select') || null;
  const duration = card ? goalMetaValue(card, 'Goal duration') : null;
  registerFlexLeaf({
    path: [...path, 'Goal Duration'],
    type: 'integer',
    description: 'How long the goal runs for, as a number. The unit is the next field.',
    existing: duration ? parseInt(duration, 10) || null : null,
    input: durationField
      ? (val) => {
          const n = String(val).replace(/[^\d]/g, '');
          return pickSelectOption(
            durationField,
            parseInt(n, 10) > 12 ? '>12' : n || String(val)
          );
        }
      : missing
  });

  const unitButtons = card
    ? Array.from(card.querySelectorAll('.neutral-toggle button'))
    : [];
  const unitLabels = unitButtons
    .map((b) => choiceButtonText(b))
    .filter((t): t is string => !!t);
  registerFlexLeaf({
    path: [...path, 'Goal Duration Unit'],
    choices: unitLabels.length > 0 ? unitLabels : GOAL_DURATION_UNITS,
    existing: activeChoiceText(unitButtons, 'neutral-toggle-btn--active') ?? null,
    input: card
      ? (val) => {
          const target = normalizeFlexKey(String(val));
          const btn = unitButtons.find(
            (b) => normalizeFlexKey(choiceButtonText(b) || '') === target
          );
          if (!btn) throw new Error(`Choice "${val}" not found`);
          if (!btn.classList.contains('neutral-toggle-btn--active'))
            (btn as HTMLElement).click();
        }
      : missing
  });

  const joined = path.join('/');
  if (!card) {
    registerFlexLeaf({
      path: [...path, 'Goal Type'],
      choices: GOAL_TYPES,
      description: 'The section the new goal shows up in.',
      input: missing
    });
    // prune_early would drop a list of blank rows, and the prototype is blank
    // by definition - it is the only way to ask for a goal that isn't there yet.
    flexBranchHints[joined] = {
      description: goalPrototypeDescription(section),
      noPrune: true
    };
    return;
  }
  // Category and status are display-only chips - branch context, not a field.
  const status = goalMetaValue(card, 'Status');
  const meta = Array.from(card.querySelectorAll('.q-chip__content'))
    .map((el) => el.textContent?.replace(/\s+/g, ' ').trim())
    .filter((t): t is string => !!t && t.length < 60);
  if (status) meta.push(`Status: ${status}`);
  if (meta.length > 0) {
    flexBranchHints[joined] = {
      description: `Existing goal context: ${Array.from(new Set(meta)).join('; ')}`
    };
  }
}

/**
 * Goals as one flex++ list under All Goals (COM-515): goals are only added there,
 * never from a section's "+ Goal". Section Goals panels repeat All Goals cards, so
 * a section card only counts when All Goals doesn't show it. The list ends in a
 * prototype row. Every goal card is marked handled to keep the generic scrapers off it.
 */
function scrapeGoalCards() {
  const allCards = Array.from(document.querySelectorAll('.q-card')).filter(
    (c) => isGoalCard(c) && !c.querySelector('.q-card')
  );
  allCards.forEach((c) => flexHandled.add(c));

  const goalKey = (card: Element) => {
    const textEl = getTextInputElement(card);
    return normalizeFlexKey(textEl ? getTextInputValue(textEl) || '' : '');
  };

  const allGoals = document.querySelector('[id="All Goals"]');
  const inAllGoals = new Set(
    allCards.filter((c) => allGoals?.contains(c)).map(goalKey)
  );
  const cards = allCards.filter((c) => {
    if (!allGoals || allGoals.contains(c)) return true;
    const key = goalKey(c);
    return !!key && !inAllGoals.has(key);
  });

  goalRowCounts = {};
  goalCards = cards;
  if (!allGoals && cards.length === 0) return;
  cards.forEach((card, index) =>
    registerGoalLeaves(goalPath(GOALS_KEY, index), card, GOALS_KEY)
  );
  goalRowCounts[GOALS_KEY] = cards.length;
  // A capture records the goals on the note: no prototype row to ask for more.
  if (captureEmptyLists) {
    if (cards.length === 0) captureEmptyLists.push([GOALS_KEY]);
  } else {
    registerGoalLeaves(goalPath(GOALS_KEY, cards.length), null, GOALS_KEY);
  }
  if (!capturingValues) console.log('flex++ goal rows:', goalRowCounts);
}

/* ------------------------------------------------------------------------ *
 * Plan of Care (COM-465): per treatment block, a Time Period select, 1-7
 * visit buttons and an Until Date picker whose Quick Select sets the date
 * N weeks from the visit. Elements are re-found at fill time: changing the
 * period can re-render the block.
 * ------------------------------------------------------------------------ */

const POC_PERIODS = [
  'Per Week',
  'Every 2 Weeks',
  'Every 3 Weeks',
  'Every 4 Weeks',
  'Every 5 Weeks',
  'Every 6 Weeks',
  'Every 8 Weeks',
  'Every 12 Weeks'
];
const POC_DURATIONS = ['2 weeks', '4 weeks', '6 weeks', '8 weeks', '10 weeks', '12 weeks'];

function planOfCareCards(): Element[] {
  return Array.from(document.querySelectorAll('[data-testid="planOfCareTypeToggle"]'))
    .map((t) => t.closest('.q-card'))
    .filter((c): c is Element => !!c && isDisplayed(c));
}

function planOfCareBlocks(card: Element): Element[] {
  return Array.from(card.querySelectorAll('[data-testid="planOfCareBlockSummary"]')).map(
    (summary) => {
      let block = summary.parentElement;
      while (block && block !== card && !block.querySelector('input[aria-label="Time Period"]'))
        block = block.parentElement;
      return block || card;
    }
  );
}

function pocField(block: Element, label: string): Element | null {
  return (
    Array.from(block.querySelectorAll('.q-field')).find((f) =>
      (f.textContent || '').includes(label)
    ) || null
  );
}

function pocCountButtons(block: Element): HTMLElement[] {
  return Array.from(block.querySelectorAll('button')).filter((b) =>
    /^[1-7]$/.test(choiceButtonText(b) || '')
  ) as HTMLElement[];
}

/** Until Date's Quick Select ("6 weeks") sets the date from the visit date. */
async function pickQuickSelect(field: Element, value: string) {
  const want = normalizeFlexKey(/^\d+$/.test(value.trim()) ? `${value} weeks` : value);
  (field.querySelector('.q-field__control') as HTMLElement | null)?.click();
  const menu = await waitFor(() =>
    openMenus().find((m) => /Quick Select/.test(m.textContent || ''))
  );
  if (!menu) throw new Error('Until Date picker did not open');
  const item = Array.from(menu.querySelectorAll('.q-item')).find(
    (i) => normalizeFlexKey(i.textContent || '') === want
  );
  if (!item) {
    pressEscape();
    throw new Error(`"${value}" is not a Quick Select option`);
  }
  (item as HTMLElement).click();
  await sleep(150);
  if (isShown(menu)) pressEscape();
}

function scrapePlanOfCare() {
  planOfCareCards().forEach((card) => {
    flexHandled.add(card);
    const blocks = planOfCareBlocks(card);
    blocks.forEach((block, i) => {
      const base: FlexPath = [sectionOf(card), 'Plan of Care'];
      if (blocks.length > 1) base.push(`Block ${i + 1}`);
      const current = () => planOfCareBlocks(card)[i];

      const period = pocField(block, 'Time Period');
      if (period) {
        registerFlexLeaf({
          path: [...base, 'Time Period'],
          choices: POC_PERIODS,
          existing:
            (period.querySelector('input') as HTMLInputElement | null)?.value || null,
          input: async (val) => {
            const field = pocField(current(), 'Time Period');
            if (!field) throw new Error('no Time Period select');
            await pickSelectOption(field, String(val));
          }
        });
      }

      const counts = pocCountButtons(block);
      if (counts.length > 0) {
        registerFlexLeaf({
          path: [...base, 'Visits Per Time Period'],
          choices: counts.map((b) => choiceButtonText(b) as string),
          description: 'Only Per Week allows more than 1; every other period is 1 visit.',
          existing: choiceButtonText(counts.find(isActiveToggle)) ?? null,
          input: (val) => {
            const btn = pocCountButtons(current()).find(
              (b) => choiceButtonText(b) === String(val).replace(/[^\d]/g, '')
            );
            if (!btn) throw new Error(`Choice "${val}" not found`);
            if ((btn as HTMLButtonElement).disabled)
              throw new Error(`${val} visits is not allowed for this Time Period`);
            if (!isActiveToggle(btn)) btn.click();
          }
        });
      }

      const until = pocField(block, 'Until Date');
      if (until) {
        const date = (until.textContent || '').match(/\d{1,2}\/\d{1,2}\/\d{4}/)?.[0];
        registerFlexLeaf({
          path: [...base, 'Duration'],
          choices: POC_DURATIONS,
          description: 'How long this block runs from the visit date; sets the Until Date.',
          existing: date ? `until ${date}` : null,
          input: async (val) => {
            const field = pocField(current(), 'Until Date');
            if (!field) throw new Error('no Until Date picker');
            await pickQuickSelect(field, String(val));
          }
        });
      }
    });
  });
}

/* ------------------------------------------------------------------------ *
 * Measurement cards and tables
 *
 * Every objective section (Pain, Function, ROM, Strength, Special Tests,
 * Palpation, Joint Mobility, Neuro Vascular...) is a list of measurement
 * cards. The generic scrapers see a card as ONE question and merge its
 * Left/Right toggles, or all of its checkbox grids, into a single choice list.
 * So cards are scraped here first, field by field, nested as
 * <Section>/<Measurement>/<Field>, then marked handled so the generic pass
 * skips them.
 * ------------------------------------------------------------------------ */

const MEASUREMENT_CARD_SELECTOR = '.q-card[id^="docEvalMeasurementId"]';
const MEASUREMENT_FIELDS_SELECTOR = '.q-pt-md.q-gutter-y-md';
const ACTIVE_TOGGLE_CLASS = 'bg-p-blue100';
// Two cards or table rows with the same name in one section become "<name>"
// and "<name> #2" branches instead of merging into one.
let flexBranchTitles = new Map<string, number>();

function uniqueBranchTitle(section: string, title: string): string {
  const key = `${section}/${normalizeFlexKey(title)}`;
  const seen = (flexBranchTitles.get(key) ?? 0) + 1;
  flexBranchTitles.set(key, seen);
  return seen > 1 ? `${title} #${seen}` : title;
}

/** display:none on the element or any ancestor (collapsed section, archived card). */
function isDisplayed(elem: Element): boolean {
  let node: Element | null = elem;
  while (node && node !== document.body) {
    if (getComputedStyle(node).display === 'none') return false;
    node = node.parentElement;
  }
  return true;
}

function isActiveToggle(btn: Element) {
  return /(^|\s)bg-p-blue\d+(\s|$)/.test(btn.className);
}

/** Toggle group (Left/Right, 0-10, Positive/Negative...) as a single-choice leaf. */
function registerToggleLeaf(
  buttons: Element[],
  path: FlexPath,
  description?: string
) {
  const real = buttons.filter((b) => !isIconButton(b));
  const interaction: Record<string, () => void> = {};
  real.forEach((b) => {
    const text = choiceButtonText(b);
    if (!text || text in interaction) return;
    interaction[text] = () => {
      if (!isActiveToggle(b)) (b as HTMLElement).click();
    };
  });
  const choices = usableChoices(real, interaction);
  if (choices.length === 0) return;
  registerFlexLeaf({
    path,
    choices,
    description,
    existing: choiceButtonText(real.find(isActiveToggle)) ?? null,
    input: (val) => clickChoice(interaction, String(val))
  });
}

/** Direct text of an element, without its child elements' text. */
function ownText(el: Element | null): string {
  if (!el) return '';
  return Array.from(el.childNodes)
    .filter((n) => n.nodeType === 3)
    .map((n) => n.textContent || '')
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Questionnaire scales (Berg, ACL-RSI, CAT, ...) rendered with .flrButton:
 *  - .flrTable rows: one question, a 0..N button row, end-point captions.
 *  - scored items: an item title, then one row per score with its meaning.
 * Each item becomes a choice leaf whose description carries the scoring key.
 */
function scrapeScaleItems(block: Element, base: FlexPath) {
  block.querySelectorAll('.flrTable').forEach((table) => {
    const labelEl = table.querySelector('.q-pb-md.relative-position');
    const label = ownText(labelEl).replace(/[.?:]\s*$/, '');
    const buttons = Array.from(table.querySelectorAll('.flrButton'));
    if (!label || buttons.length === 0) return;
    const captions = Array.from(table.querySelectorAll('.text-caption'))
      .map((c) => c.textContent?.trim() || '')
      .filter(Boolean);
    const first = choiceButtonText(buttons[0]);
    const last = choiceButtonText(buttons[buttons.length - 1]);
    const scale =
      captions.length >= 2
        ? `${first} = ${captions[0]}, ${last} = ${captions[captions.length - 1]}`
        : captions[0] || '';
    registerToggleLeaf(buttons, [...base, label], scale || undefined);
  });

  Array.from(block.querySelectorAll('div.q-mb-md'))
    .filter(
      (g) => g.querySelector(':scope > .row > .flrButton') && !g.closest('.flrTable')
    )
    .forEach((group) => {
      const titleEl = Array.from(group.children).find(
        (c) => !c.querySelector('.flrButton') && ownText(c)
      );
      const label = ownText(titleEl || null).replace(/[.:]\s*$/, '');
      const rows = Array.from(group.querySelectorAll(':scope > .row'));
      const buttons = rows
        .map((r) => r.querySelector('.flrButton'))
        .filter((b): b is Element => !!b);
      if (!label || buttons.length === 0) return;
      const key = rows
        .map((r) => {
          const score = choiceButtonText(r.querySelector('.flrButton') || undefined);
          const meaning = r.querySelector('.self-center')?.textContent?.trim();
          return score && meaning ? `${score} = ${meaning}` : '';
        })
        .filter(Boolean)
        .join('; ');
      const task = ownText(group.previousElementSibling);
      const description = [task, key].filter(Boolean).join(' ');
      registerToggleLeaf(buttons, [...base, label], description || undefined);
    });
}

/** Checkbox grid (Pain Descriptors, palpation findings...) as a multi-choice leaf. */
function registerCheckboxLeaf(boxes: Element[], path: FlexPath) {
  const interaction: Record<string, () => void> = {};
  const checked: string[] = [];
  boxes.forEach((box) => {
    const inner = box.querySelector('.q-checkbox__inner');
    const label =
      box.getAttribute('aria-label')?.trim() || box.textContent?.trim();
    if (!inner || !label || label in interaction) return;
    if (inner.classList.contains('q-checkbox__inner--truthy')) checked.push(label);
    interaction[label] = () => {
      if (!inner.classList.contains('q-checkbox__inner--truthy'))
        (inner as HTMLElement).click();
    };
  });
  const choices = Object.keys(interaction);
  if (choices.length === 0) return;
  registerFlexLeaf({
    path,
    choices,
    multiple: true,
    existing: checked.length > 0 ? checked.join(', ') : null,
    selected: checked,
    input: (vals) =>
      checkChoices(boxes[0]?.parentElement?.parentElement ?? null, interaction, vals, path.join('/'))
  });
}

function fillNativeInput(input: HTMLInputElement, val: string) {
  bubbleFocus(input);
  input.focus();
  nativeInputFill(input, val);
  input.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
  input.blur();
}

/**
 * Numeric measurement (degrees, lbs, cm) with an optional WNL/WFL style toggle
 * beside it. One leaf: a number fills the input, a toggle label clicks it.
 */
function registerMeasureLeaf(
  input: HTMLInputElement,
  toggles: Element[],
  path: FlexPath
) {
  const real = toggles.filter((b) => !isIconButton(b));
  const interaction: Record<string, () => void> = {};
  real.forEach((b) => {
    const text = choiceButtonText(b);
    if (!text || text in interaction) return;
    interaction[text] = () => {
      if (!isActiveToggle(b)) (b as HTMLElement).click();
    };
  });
  const choices = usableChoices(real, interaction);
  const existing =
    input.value?.trim() || choiceButtonText(real.find(isActiveToggle)) || null;
  registerFlexLeaf({
    path,
    type: choices.length > 0 ? 'string' : 'number',
    description:
      choices.length > 0
        ? `One bare value: a number, or exactly one of ${choices
            .map((c) => `"${c}"`)
            .join(', ')}. No units, qualifiers or second value; ` +
          `if the visit gives more than one reading, use the most recent. ` +
          `"None" if not measured.`
        : undefined,
    existing,
    input: (val) => {
      const text = String(val).trim();
      const match = Object.keys(interaction).find(
        (c) => normalizeFlexKey(c) === normalizeFlexKey(text)
      );
      if (match) return interaction[match]();
      fillNativeInput(input, text);
    }
  });
}

/** Label of a field block: its own subtitle/caption, or the memo's floating label. */
function blockLabel(block: Element): string {
  const el = block.querySelector(
    ':scope > .text-subtitle1, :scope > .text-caption, .q-field__label, [label]'
  );
  const text =
    el?.classList.contains('q-field__label') === false && el?.hasAttribute('label')
      ? el.getAttribute('label')
      : el?.textContent;
  return stripRecordedSuffix((text || '').trim());
}

/**
 * The card body is a list of blocks, one per field (a toggle row, a checkbox
 * grid with its heading, a memo, a numeric input with its stepper).
 */
function scrapeMeasurementFields(card: Element, base: FlexPath) {
  const area = card.querySelector(MEASUREMENT_FIELDS_SELECTOR) || card;
  Array.from(area.children).forEach((block) => {
    if (block.querySelector('.flrButton')) {
      scrapeScaleItems(block, base);
      return;
    }
    const label = blockLabel(block);
    const memos = Array.from(block.querySelectorAll('div[contenteditable]'));
    const inputs = Array.from(
      block.querySelectorAll('input.q-field__native')
    ).filter((i) => !i.closest('.q-checkbox')) as HTMLInputElement[];

    // Numeric measurement, possibly with a WNL/WFL toggle group beside it.
    if (inputs.length > 0) {
      const toggles = Array.from(
        block.querySelectorAll('.q-btn-group button, .radioGroup button')
      );
      inputs.forEach((input) => {
        // A lone unlabeled value (Observation girth cards) is the measurement itself.
        const path =
          label || inputs.length > 1 || memos.length > 0
            ? [...base, label || 'Measurement']
            : base;
        registerMeasureLeaf(input, inputs.length > 1 ? [] : toggles, path);
      });
    }

    const groups = inputs.length > 0 ? [] : Array.from(block.querySelectorAll('.radioGroup'));
    groups.forEach((group) => {
      const own =
        group.parentElement?.querySelector(':scope > .text-subtitle1')?.textContent?.trim() ||
        label ||
        'Result';
      registerToggleLeaf(Array.from(group.querySelectorAll('button')), [...base, own]);
    });

    const boxes = Array.from(block.querySelectorAll('.q-checkbox'));
    if (boxes.length > 0) registerCheckboxLeaf(boxes, [...base, label || 'Findings']);

    memos.forEach((memo) => {
      const own =
        memo.closest('.q-field')?.querySelector('.q-field__label')?.textContent?.trim() ||
        memo.closest('[label]')?.getAttribute('label')?.trim() ||
        label ||
        'Note';
      registerFlexLeaf({
        path: [...base, stripRecordedSuffix(own)],
        existing: memoValue(memo as HTMLElement) || null,
        input: (val, replyType) => fillMemo(memo as HTMLElement, val, replyType)
      });
    });
  });
}

/** ROM / Strength grids: one branch per row, one leaf per column. */
function scrapeMeasurementTable(table: Element) {
  const section = sectionOf(table);
  const columns = Array.from(table.querySelectorAll('.measurement-header > *'))
    .map((h) => h.textContent?.trim() || '')
    .slice(1);
  table.querySelectorAll('.measurement-row').forEach((row) => {
    const name = stripRecordedSuffix(
      row.querySelector('.measurement-label-col .text-weight-medium')?.textContent?.trim() || ''
    );
    if (!name || !isDisplayed(row)) return;
    const base: FlexPath = [section, uniqueBranchTitle(section, name)];
    row.querySelectorAll('.measurement-data-col').forEach((cell, i) => {
      const column = columns[i] || `Column ${i + 1}`;
      const input = cell.querySelector('input.q-field__native') as HTMLInputElement | null;
      const buttons = Array.from(cell.querySelectorAll('button')).filter(
        (b) => !b.closest('.q-field')
      );
      if (input) registerMeasureLeaf(input, buttons, [...base, column]);
      else if (buttons.length > 0) registerToggleLeaf(buttons, [...base, column]);
    });
  });
  flexHandled.add(table);
}

/**
 * Prompt remembers a collapsed card, and a collapsed card has no fields in the
 * DOM. Open it via its own expand toggle; put it back if nothing appeared.
 */
async function expandMeasurementCard(card: Element): Promise<boolean> {
  if (card.querySelector(MEASUREMENT_FIELDS_SELECTOR)) return true;
  const toggle = cardExpandToggle(card);
  if (!toggle) return false;
  toggle.click();
  await sleep(250);
  if (card.querySelector(MEASUREMENT_FIELDS_SELECTOR)) return true;
  toggle.click();
  return false;
}

/** Collapsed cards open via a pencil (edit) or chevron icon button. */
function cardExpandToggle(card: Element): HTMLElement | undefined {
  return Array.from(card.querySelectorAll('button')).find(
    (b) =>
      /\b(edit|expand_more|expand_less|keyboard_arrow_down|unfold_more)\b/.test(
        b.textContent || ''
      ) || b.querySelector('[class*="mdi-pencil"], [class*="mdi-chevron"]')
  ) as HTMLElement | undefined;
}

/** Closed measurement cards show a pencil instead of their fields. */
function collapsedCardPencils(): HTMLElement[] {
  return Array.from(document.querySelectorAll('button')).filter((b) => {
    const icon = b.querySelector('i');
    return (
      !!icon &&
      icon.textContent?.trim() === 'edit' &&
      sectionOf(b) !== 'General' &&
      isDisplayed(b)
    );
  }) as HTMLElement[];
}

/** Click every pencil in the document sections, then wait for the cards to render. */
async function openCollapsedCards() {
  const pencils = collapsedCardPencils();
  if (pencils.length === 0) return;
  pencils.forEach((b) => b.click());
  for (let i = 0; i < 20; i++) {
    await sleep(150);
    if (collapsedCardPencils().length === 0) break;
  }
  console.log('flex++ opened cards:', pencils.length);
}

type MeasurementStats = {
  cards: number;
  hidden: number;
  expanded: number;
  empty: number;
  leaves: number;
};

/** The title a card registers under, or null for a card that is skipped. */
function claimMeasurementCard(card: Element, stats: MeasurementStats) {
  if (isGoalCard(card) || isFlexHandled(card)) return null;
  stats.cards++;
  if (!isDisplayed(card)) {
    stats.hidden++;
    return null;
  }
  const title = stripRecordedSuffix(
    card.querySelector('.text-subtitle1')?.textContent?.trim() || ''
  );
  flexHandled.add(card);
  return title || null;
}

/** Register an open card's fields; returns how many leaves it added. */
function scrapeMeasurementCard(card: Element, title: string) {
  const section = sectionOf(card);
  const before = flexLeaves.length;
  scrapeMeasurementFields(card, [section, uniqueBranchTitle(section, title)]);
  return flexLeaves.length - before;
}

function scrapeMeasurementTables() {
  document.querySelectorAll('.measurement-table').forEach((table) => {
    if (isDisplayed(table)) scrapeMeasurementTable(table);
  });
}

async function scrapeMeasurementCards() {
  const stats = { cards: 0, hidden: 0, expanded: 0, empty: 0, leaves: 0 };
  const cards = Array.from(document.querySelectorAll(MEASUREMENT_CARD_SELECTOR));
  for (const card of cards) {
    const title = claimMeasurementCard(card, stats);
    if (title === null) continue;
    const hadFields = !!card.querySelector(MEASUREMENT_FIELDS_SELECTOR);
    if (!(await expandMeasurementCard(card))) {
      stats.empty++;
      continue;
    }
    if (!hadFields) stats.expanded++;
    stats.leaves += scrapeMeasurementCard(card, title);
  }
  scrapeMeasurementTables();
  console.log('flex++ measurement cards:', stats);
}

async function waitFor<T>(find: () => T | null | undefined, ms = 3000): Promise<T | null> {
  for (let waited = 0; waited <= ms; waited += 100) {
    const found = find();
    if (found) return found;
    await sleep(100);
  }
  return null;
}

function shownButton(root: ParentNode, text: RegExp): HTMLElement | null {
  return (
    (Array.from(root.querySelectorAll('button')).find(
      (b) => isShown(b) && text.test((b.textContent || '').trim())
    ) as HTMLElement) || null
  );
}

/** A closed Quasar drawer stays in the DOM, slid out and marked prevent-focus. */
function isDrawerOpen(drawer: Element) {
  return isShown(drawer) && !drawer.classList.contains('q-layout--prevent-focus');
}

/** Opens on whichever tab was used last, so match its Templates / All Goals tabs. */
function addGoalsDialog(): HTMLElement | null {
  return (
    (Array.from(document.querySelectorAll('.q-dialog')).find(
      (d) =>
        isShown(d) &&
        !!shownButton(d, /^Templates\s*\d*$/) &&
        !!shownButton(d, /^All Goals\s*\d*$/)
    ) as HTMLElement) || null
  );
}

function selectedGoalCount(dialog: Element): number {
  const text = shownButton(dialog, /^Review Goal Selections/)?.textContent || '';
  return parseInt(text.replace(/\D/g, ''), 10) || 0;
}

function goalValue(row: any, key: string): string | null {
  const value = flexLookupChild(row, key);
  if (isEmptyFlexPayload(value) || /^none$/i.test(String(value).trim())) return null;
  return String(value).trim();
}

/**
 * COM-530: one empty library goal per Goal Type, created once and reused, so
 * the library doesn't grow per note. The Goal Type tag picks the section the
 * goal shows up in; the note's card is filled like any other goal.
 */
function goalType(row: any): string | null {
  const value = normalizeFlexKey(goalValue(row, 'Goal Type') || '');
  return GOAL_TYPES.find((t) => normalizeFlexKey(t) === value) ?? null;
}

function templateGoalTitle(type: string | null): string {
  return type ? `Empty ${type} Goal` : 'Empty General Goal';
}

function libraryGoalCard(dialog: Element, title: string): HTMLElement | null {
  return (
    (Array.from(dialog.querySelectorAll('.q-card')).find(
      (c) =>
        !!c.querySelector('.q-checkbox') &&
        Array.from(c.querySelectorAll('*')).some(
          (e) => e.children.length === 0 && e.textContent?.trim() === title
        )
    ) as HTMLElement) || null
  );
}

async function searchGoals(dialog: Element, title: string) {
  const search = dialog.querySelector(
    'input[placeholder="Search for goals"]'
  ) as HTMLInputElement | null;
  if (!search) return;
  nativeInputFill(search, '');
  nativeInputFill(search, title);
}

/** Create New > Create an individual Goal: title and Goal Type only. */
async function createTemplateGoal(dialog: Element, title: string, type: string | null) {
  const createNew = await waitFor(() => shownButton(dialog, /^Create New$/));
  if (!createNew) throw new Error('no Create New button');
  createNew.click();
  const item = await waitFor(() =>
    openMenus()
      .flatMap((m) => Array.from(m.querySelectorAll('.q-item')))
      .find((i) => /individual goal/i.test(i.textContent || ''))
  );
  if (!item) throw new Error('no "Create an individual Goal" option');
  (item as HTMLElement).click();

  const drawer = await waitFor(() =>
    Array.from(dialog.querySelectorAll('aside.q-drawer')).find(
      (a) => isDrawerOpen(a) && /Goal Title/.test(a.textContent || '')
    )
  );
  if (!drawer) throw new Error('Add Goal drawer did not open');
  const titleInput = Array.from(drawer.querySelectorAll('.q-field'))
    .find((f) => /Goal Title/.test(f.textContent || ''))
    ?.querySelector('input.q-field__native') as HTMLInputElement | null;
  if (!titleInput) throw new Error('no Goal Title input');
  nativeInputFill(titleInput, title);
  if (type) {
    const typeField = Array.from(drawer.querySelectorAll('.q-select')).find((f) =>
      /Goal Type/.test(f.textContent || '')
    );
    if (!typeField) throw new Error('no Goal Type select');
    await pickSelectOption(typeField, type);
  }
  shownButton(drawer, /^Create$/)?.click();
  if (!(await waitFor(() => !isDrawerOpen(drawer)))) {
    throw new Error(`goal "${title}" was not created`);
  }
}

/** All Goals > Templates > All Goals tab: tick the row's template goal, then Add Selected Goals. */
async function addTemplateGoal(row: any): Promise<boolean> {
  const panel = document.querySelector('[id="All Goals"]');
  const templates = panel && shownButton(panel, /^Templates$/);
  if (!templates) throw new Error('no Templates button in All Goals');
  templates.click();
  const dialog = await waitFor(addGoalsDialog);
  if (!dialog) throw new Error('Add Goals dialog did not open');
  shownButton(dialog, /^All Goals\s*\d*$/)?.click();
  await sleep(500);

  const type = goalType(row);
  const title = templateGoalTitle(type);
  const before = selectedGoalCount(dialog);
  await searchGoals(dialog, title);
  let card = await waitFor(() => libraryGoalCard(dialog, title), 1500);
  if (!card) {
    await createTemplateGoal(dialog, title, type);
    if (!(await waitFor(() => selectedGoalCount(dialog) > before, 1000))) {
      await searchGoals(dialog, title);
      card = await waitFor(() => libraryGoalCard(dialog, title));
    }
  }
  if (selectedGoalCount(dialog) <= before) {
    (card?.querySelector('.q-checkbox') as HTMLElement | null)?.click();
    if (!(await waitFor(() => selectedGoalCount(dialog) > before))) {
      throw new Error(`goal "${title}" could not be selected`);
    }
  }

  const add = await waitFor(() => {
    const b = shownButton(dialog, /^Add Selected Goals$/) as HTMLButtonElement | null;
    return b && !b.disabled && !b.classList.contains('disabled') ? b : null;
  });
  if (!add) throw new Error('Add Selected Goals stayed disabled');
  add.click();
  return !!(await waitFor(() => !addGoalsDialog(), 5000));
}

/** Re-read every goal list: a new goal shows up in its section and All Goals. */
function rescrapeGoals() {
  flexPathSeen = new Map();
  flexHandled = new WeakSet();
  flexLeaves = flexLeaves.filter(
    (l) => l.path[0] !== GOALS_KEY && l.path[1] !== GOALS_KEY
  );
  Object.keys(flexBranchHints)
    .filter(
      (k) => k.startsWith(`${GOALS_KEY}/`) || k.includes(`/${GOALS_KEY}/`)
    )
    .forEach((k) => delete flexBranchHints[k]);
  scrapeGoalCards();
  flexDocTree = buildInteractionTree(flexLeaves);
  Object.entries(flexSectionTrees).forEach(([name, entry]) => {
    entry.tree = entry.wrapped
      ? { [name]: flexDocTree[name] }
      : flexDocTree[name];
  });
}

/**
 * Add a template goal per new row the AI returned, in All Goals only, one at a
 * time so each new card maps to its row. Returns the payload re-indexed to the
 * cards now on screen; new rows fill their card.
 */
async function ensureGoalRows(section: string, payload: any) {
  if (section !== GOALS_KEY) return payload;
  const wanted = requestedRowCount(payload, [GOALS_KEY]);
  const current = goalRowCounts[section] ?? 0;
  if (wanted <= current) return payload;

  const rows = normalizeIndexedDict(flexLookupChild(payload, GOALS_KEY));
  const key =
    Object.keys(payload).find((k) => normalizeFlexKey(k) === normalizeFlexKey(GOALS_KEY)) ??
    GOALS_KEY;
  // The AI pads with a "None" / "Not Discussed" row: not a goal.
  const created = rows
    .slice(current, wanted)
    .filter((row: any) => goalValue(row, 'Goal Description'));
  if (created.length === 0) return { ...payload, [key]: rows.slice(0, current) };

  const before = goalCards.slice();
  const added = new Map<Element, any>();
  for (const row of created) {
    const known = new Set(goalCards);
    try {
      await addTemplateGoal(row);
    } catch (e) {
      console.warn(`[Prompt] could not add goal in All Goals: ${e}`);
      // Escape only: closeOverlay hides a stuck dialog, and Prompt reuses this one.
      for (let i = 0; i < 5 && addGoalsDialog(); i++) {
        pressEscape();
        await sleep(300);
      }
      break;
    }
    await sleep(500);
    rescrapeGoals();
    const card = goalCards.find((c) => {
      const text = getTextInputElement(c);
      return !known.has(c) && !added.has(c) && !!text && !getTextInputValue(text);
    });
    if (card) {
      added.set(
        card,
        Object.fromEntries(
          Object.entries(row).filter(([k]) => normalizeFlexKey(k) !== 'goal type')
        )
      );
    }
  }
  return {
    ...payload,
    [key]: goalCards.map((c) => added.get(c) ?? rows[before.indexOf(c)] ?? {})
  };
}

/** A node carrying only reserved keys is a field, not a group of fields. */
function isFlexLeafSchema(node: any): boolean {
  if (node === null || typeof node !== 'object' || Array.isArray(node)) {
    return true;
  }
  return Object.keys(node).every((key) => key.startsWith('_'));
}

/** One nested Flex question per top-level section of the Prompt document. */
function buildFlexSectionQuestions() {
  flexDocTree = buildInteractionTree(flexLeaves);
  flexSectionTrees = {};

  // No prune_early: the backend's prune pass is an AI vote that drops any branch
  // with no existing value, which on a fresh eval is every field being dictated
  // into. Splitting the document per section already keeps each call far under
  // the flex++ caps (largest section ~67 props / 198 enums / 6KB vs 5000/1000/120k).
  const structure = buildFlexStructure(flexLeaves, flexBranchHints);
  const sectionQuestions: any[] = [];

  // Panel order: SOAP first, then the document's own anchor-rail order.
  const rail = Array.from(document.querySelectorAll('[anchor-key]')).map((a) => {
    const key = a.getAttribute('anchor-key')?.trim() || '';
    return key === 'All Goals' ? GOALS_KEY : key;
  });
  const order = [...rail];
  const rank = (key: string) => {
    const i = order.indexOf(key);
    return i === -1 ? order.length : i;
  };
  const sections = Object.keys(structure).sort((a, b) => rank(a) - rank(b));
  for (const section of sections) {
    if (section === FLEXPP_TOGGLE_KEY || section === 'prune_early') continue;
    const subtree = structure[section];
    if (subtree === null || typeof subtree !== 'object') continue;

    // The panel shows a question's own name as the row and the top-level keys of
    // its structure as the View More entries, so a group of named children is
    // fronted directly (Pain -> Pain Comments). A single field or a list has no
    // children to front and keeps its own name as the root key.
    const wrapped = Array.isArray(subtree) || isFlexLeafSchema(subtree);
    const sectionStructure: Record<string, any> = wrapped
      ? { [section]: subtree }
      : { ...subtree };
    if (Object.keys(sectionStructure).length === 0) continue;
    sectionStructure[FLEXPP_TOGGLE_KEY] = true;

    flexSectionTrees[section] = {
      tree: wrapped ? { [section]: flexDocTree[section] } : flexDocTree[section],
      wrapped
    };
    questionInteractions[section] = {
      Type: 'Flex',
      Key: section,
      Question: section,
      Structure: sectionStructure
    };
    sectionQuestions.push({
      Key: section,
      Question: section,
      Type: 'Flex',
      Choices: [],
      Structure: sectionStructure
    });
  }

  return sectionQuestions;
}

export async function getQuestions() {
  // Return cached results if the last successful computation was within 10 seconds
  const now = Date.now();
  if (cachedQuestions && now - lastGetQuestionsAt < 10000) {
    return cachedQuestions;
  }
  // If we're actively answering questions, don't re-scrape — return cache regardless
  // of the 10s window. Cache will be invalidated when each question finishes.
  if (cachedQuestions && __overlayAnswerQueue.length > 0) {
    return cachedQuestions;
  }

  beginOverlay(
    'Finding sections we can complete for you. This won’t take long..',
    { title: 'ComprehendPT' }
  );
  try {
    const result = await getQuestionsInner();
    // Only a successful scrape is cached; getQuestionsInner returns undefined on error.
    if (result) {
      cachedQuestions = result;
      lastGetQuestionsAt = Date.now();
    }
    return result;
  } finally {
    endOverlay();
  }
}

/** Expand Prompt to fullscreen before scraping; "fullscreen_exit" means it already is. */
async function ensureFullscreen() {
  const icon = Array.from(
    document.querySelectorAll('.q-btn__content i.material-icons')
  ).find((i) => i.textContent?.trim() === 'fullscreen');
  const btn = icon?.closest('.q-btn') as HTMLElement | null;
  if (!btn) return;
  btn.click();
  await sleep(500);
}

async function getQuestionsInner() {
  try {
    // Get the questions
    questions = [];
    questionInteractions = {};
    flexLeaves = [];
    flexBranchHints = {};
    flexDocTree = {};
    flexSectionTrees = {};
    flexPathSeen = new Map();
    flexHandled = new WeakSet();
    flexRegisteredInputs = new WeakSet();
    sectionIdCache = null;
    flexBranchTitles = new Map();
    await ensureFullscreen();
    await openCollapsedCards();
    await scrapeMeasurementCards();
    scrapeGoalCards();
    scrapePlanOfCare();

    var q = document.querySelectorAll('.q-pa-md');
    console.log('Questions');
    console.log(q);
    var section1 = q[0].firstChild.textContent.trim();

    // Store the scroll position
    const scrollTop = document.querySelector('#patientContainer').scrollTop;

    // For each of the questions
    for (var i = 1; i < q.length; i++) {
      try {
        await extractQuestionBlock(q[i]);
      } catch (error) {
        console.error('Error in loop iteration:', error);
        getLogFromInjector();
        // Handle error as needed
      }
    }
    extractAllSectionComments(); //doing here to avoid the order of questions mess up
    await getFlowsheet();
    await closeStrayOverlays();
    console.log('Questions');
    console.log(questions);
    resolveQuestionsLoaded();

    // for each of the question add a new key called "Key" with the same value of "Question"
    for (var i = 0; i < questions.length; i++) {
      // Sometimes these labels will contain text such as "(Last Recorded on 11/21/2023)" we need to nuke and trim this
      questions[i]['Key'] = questions[i]['Question'];
    }

    // Reset the scroll
    document.querySelector('#patientContainer').scrollTop = scrollTop;
    // Remove Null and empty questions
    questions = questions.filter(
      (question) =>
        question !== null && question !== undefined && question.Question !== ''
    );

    // Remove Goal Progress (%) questions
    questions = questions.filter(
      (question) =>
        question.Question && !question.Question.includes('Goal Progress (%)')
    );

    // Remove Flex questions with no structure (e.g. Flowsheet with empty table)
    questions = questions.filter(
      (question) =>
        question.Type !== 'Flex' || Object.keys(question.Structure ?? {}).length > 0
    );

    // Remove noise questions from Prompt
    // Drops "Treatment Notes", "Treatment Notes (Never Completed)", and any other suffixed variant.
    // Note: the Flowsheet Flex structure holds its own 'Treatment Notes' key, so it is unaffected.
    questions = questions.filter(
      (question) => !question.Question?.trim().startsWith('Treatment Notes')
    );

    // One nested question per section, so each section is its own row in the
    // panel rather than a View More entry under a single 'Document' question.
    const sectionQuestions = [...soapQuestions(), ...buildFlexSectionQuestions()];
    console.log(
      'flex++ sections:',
      sectionQuestions.map((q) => `${q.Question} (${q.Type})`)
    );
    console.log('flex++ section structures:', sectionQuestions);
    return sectionQuestions;
  } catch (error) {
    // Handle error if it wasn't caught within the loop
    console.error('Error in getQuestions:', error);
    getLogFromInjector();
    // Send error to fetchDocument() or handle it as needed
  }
}

/* One `.q-pa-md` block of the document, by the kind of question it holds. */
async function extractQuestionBlock(block) {
  // Check for the top level questions
  if (block.querySelectorAll('.q-mb-md').length > 0) {
    await topLevelShortAnswer(block);
  } else if (block.querySelector('[role="combobox"]')) {
    // Choose all - Toggle Box
    // await comboBoxQuestion(block);
    // We don't even work with the CPT Codes so let's not scroll down so hard
  } else if (block.querySelector('.q-px-md')) {
    // Check if it is a choose all question
    await chooseAllQuestion(block);
  } else if (
    block.querySelector('.radioGroup') &&
    !getTextInputElement(block)
  ) {
    // Added the check for a text area for goal questions
    // Multiple Choice
    await multipleChoiceQuestion(block);
    // TODO: This is too generic...
  } else if (getTextInputElement(block)) {
    // Long Answer Question (textarea or contenteditable div)
    await longAnswerQuestion(block);
  } else {
    // console.log("Unknown Question Type")
    // console.log(block)
  }
}

// All the questions have their own function so we can call them individually
async function topLevelShortAnswer(question) {
  // console.log("Top Level Long Answer")
  var shortAnswer1 = question.querySelectorAll('.q-mb-md');

  var qType = 'Long Answer';

  // Subjective, Objective, Assessment, Plan
  shortAnswer1.forEach((element) => {
    var qText = element.firstChild?.getAttribute?.('label');
    if (!qText)
      qText = element
        .querySelector('.command-input-label')
        ?.textContent?.trim();
    if (!qText) qText = element.querySelector('[label]')?.getAttribute('label');
    if (!qText)
      qText = element.querySelector('.q-field__label')?.textContent?.trim();
    if (!qText) return; // skip structural wrappers with no label

    var qInteraction = {};
    var existingNoteElement = getTextInputElement(element);
    if (existingNoteElement) {
      qInteraction['ExistingNote'] = getExistingNote(
        getTextInputValue(existingNoteElement)
      );
    }
    qInteraction['Input'] = (val, replyType) =>
      textBoxUpdate(getTextInputElement(element), val, replyType); // Store the interaction for later

    try {
      qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
    } catch (e) {
      console.error(
        'Error removing the last recorded text, trying as a long answer directly'
      );
      return longAnswerQuestion(question);
    }

    questions.push({
      Question: qText,
      Type: qType,
      ExistingNote: qInteraction['ExistingNote'],
      Choices: []
    });
    questionInteractions[qText] = qInteraction;
    registerFieldLeaf(
      element,
      qText,
      {
        existing: qInteraction['ExistingNote'],
        input: (val, replyType) =>
          textBoxUpdate(getTextInputElement(element), val, replyType)
      },
      getTextInputElement(element)
    );
  });
}

async function comboBoxQuestion(question) {
  // console.log("ComboBox Question")
  var cpt = question.querySelector('[role="combobox"]');

  var qText = getParentSubtitle(cpt);
  // if qText starts with "This template will"
  if (qText.startsWith('This template will')) {
    return null;
  }

  var qType = 'Choose All';
  var qInteraction = {};
  var qChoices = [];

  // Show the choices drop down
  cpt.dispatchEvent(eventFactory('focusin'));
  cpt.dispatchEvent(eventFactory('click'));

  // Rather than using a while loop with a sleep, we could use a promise

  return waitForElementToDisplay('[role="listbox"]', 2000)
    .then(function () {
      // console.log("List Box found!")
      var lBox = document.querySelector('[role="listbox"]');
      var qChoicesElement = lBox.querySelectorAll('.q-item__section');
      qChoicesElement.forEach((element) => {
        // var choice = element.textContent.trim().replaceAll("\n        ","")
        // Rather than getting the code and description, just get the code
        var choice = element.firstChild.textContent.trim();
        qChoices.push(choice);
        qInteraction[choice] = () =>
          tryToClick(() => choiceClicker(cpt, choice), 5);
      });

      try {
        qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
      } catch (e) {
        console.error('Error removing the last recorded text');
        getLogFromInjector();
      }

      // Push the choices to the questions
      questions.push({ Question: qText, Type: qType, Choices: qChoices });
      questionInteractions[qText] = qInteraction;
      console.log(questions[questions.length - 1]);
      // Close the choices drop down
      cpt.dispatchEvent(eventFactory('click'));
      return true;
    })
    .catch(function () {
      console.error('List Box not found');

      return null;
    });
}

async function chooseAllQuestion(question) {
  // console.log("Choose All Question")
  var chooseAll = question.querySelectorAll('.q-px-md');
  var qText = getChildSubtitle(question);
  if (!qText) return;
  var qType = 'Choose All';
  var qChoices = [];

  var qInteraction = {};

  chooseAll.forEach((element) => {
    // Make sure we have a checkbox (Plan of care was coming here and failing)
    if (!element.querySelector('.q-checkbox__inner')) {
      return;
    }
    var choiceText = element.textContent.trim();
    qChoices.push(choiceText);
    qInteraction[choiceText] = () => {
      if (
        !element
          .querySelector('.q-checkbox__inner')
          .classList.contains('q-checkbox__inner--truthy')
      ) {
        element.querySelector('.q-checkbox__inner').click(); // This is how we click it
      }
    };
  });

  try {
    qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
  } catch (e) {
    console.error('Error removing the last recorded text');
    getLogFromInjector();
  }

  questions.push({ Question: qText, Type: qType, Choices: qChoices });
  questionInteractions[qText] = qInteraction;
  const checked = (Array.from(chooseAll) as Element[])
    .filter((el) =>
      el
        .querySelector('.q-checkbox__inner')
        ?.classList.contains('q-checkbox__inner--truthy')
    )
    .map((el) => el.textContent?.trim())
    .filter((t): t is string => !!t);
  registerFieldLeaf(
    question,
    qText,
    {
      choices: qChoices,
      multiple: true,
      existing: checked.length > 0 ? checked.join(', ') : null,
      selected: checked,
      input: (vals) => checkChoices(question, qInteraction, vals, qText)
    },
    question
  );
}

function extractAllSectionComments() {
  // Find all visible q-card elements
  const qCards = document.querySelectorAll('.q-card');

  qCards.forEach((qCard) => {
    try {
      // Check if the q-card element is visible
      if (getComputedStyle(qCard).display !== 'none') {
        // Within each visible q-card, find all text areas
        const sections = qCard.querySelectorAll('div[contenteditable]');

        sections.forEach((section) => {
          // Find the closest parent element with class 'relative-position full-width'
          const parentElement = section.closest(
            '.relative-position.full-width'
          );

          const headerElement = parentElement.querySelector('.q-field__label');
          const captionElement = parentElement.parentElement?.querySelector(
            ':scope > .text-body2'
          );
          const header = (
            headerElement?.textContent?.trim() ||
            captionElement?.textContent?.trim() ||
            ''
          );
          const textArea = getTextInputElement(section.parentElement);

          if (header && textArea) {
            const comment = getTextInputValue(textArea).trim();

            // Update header text to remove "(Last recorded on [date])" and make it generic
            let qText = header.replace(/\(Last recorded.*?\)/, '').trim();
            // Optionally, replace specific labels with a generic "Comments"
            if (qText) {
              qText = qText.replace(/Based Assessment$/, 'Comments'); // Generic replacement
            }

            const qType = 'Long Answer';
            const qChoices = [];
            const qInteraction = {
              ExistingNote: comment,
              Input: (val, replyType) => textBoxUpdate(textArea, val, replyType)
            };

            questions.push({
              Question: qText,
              Type: qType,
              ExistingNote: qInteraction['ExistingNote'],
              Choices: qChoices
            });

            // Remove duplicate questions
            const uniqueQuestions = Array.from(
              new Map(questions.map((q) => [q.Question, q])).values()
            );
            questions = uniqueQuestions;
            questionInteractions[qText] = qInteraction;
            captureOwners?.set(qText, sectionOf(section));
            registerFieldLeaf(
              section,
              qText,
              {
                existing: comment,
                input: (val, replyType) =>
                  textBoxUpdate(textArea, val, replyType)
              },
              textArea
            );
          }
        });
      }
    } catch (error) {
      if (!capturingValues) {
        console.error('Error extracting comments for section:', error);
      }
    }
  });

  if (!capturingValues) console.log('questions', questions);
}

async function multipleChoiceQuestion(question) {
  // console.log("Multiple Choice Question")
  var mcChoice = question.querySelectorAll('button');
  var qText = getChildSubtitle(question);
  if (!qText || qText == 'Measurements') {
    return null;
  }

  // if qText starts with "This template will"
  if (qText.startsWith('This template will')) {
    return null;
  }

  var qType = 'Multiple Choice';
  var qChoices = [];
  var qInteraction = {};

  mcChoice.forEach((element) => {
    var choiceText = element
      .querySelector('.q-btn__content')
      .firstChild.firstChild.textContent.trim();
    qChoices.push(choiceText);

    qInteraction[choiceText] = () => {
      if (!element.classList.contains('bg-p-blue100')) {
        element.click(); // (Toggles so we have to check it first)
      }
    };
  });

  try {
    qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
  } catch (e) {
    console.error('Error removing the last recorded text');
    getLogFromInjector();
  }

  questions.push({ Question: qText, Type: qType, Choices: qChoices });
  questionInteractions[qText] = qInteraction;
  const mcButtons = Array.from(mcChoice) as Element[];
  const mcChoices = usableChoices(mcButtons, qInteraction);
  if (mcChoices.length > 0) {
    registerFieldLeaf(
      question,
      qText,
      {
        choices: mcChoices,
        existing: activeChoiceText(
          mcButtons.filter((b) => !isIconButton(b)),
          'bg-p-blue100'
        ),
        input: (val) => clickChoice(qInteraction, val)
      },
      question
    );
  }
}

async function longAnswerQuestion(question) {
  // console.log("Long Answer Question")
  var qText = getChildSubtitle(question);
  if (!qText || qText == 'Measurements') {
    return null;
  }

  var qType = 'Long Answer';
  var qChoices = [];
  var qInteraction = {};
  var existingNoteElement = getTextInputElement(question);
  if (existingNoteElement) {
    qInteraction['ExistingNote'] = getExistingNote(
      getTextInputValue(existingNoteElement)
    );
  }
  qInteraction['Input'] = (val, replyType) =>
    textBoxUpdate(getTextInputElement(question), val, replyType); // Store the interaction for later

  const flexLabel = stripRecordedSuffix(qText);

  // Check if there is already an entry in questionInterations with qText, if so append a number to it
  if (qText in questionInteractions) {
    var i = 1;
    var qTextTemp = qText;
    while (qTextTemp in questionInteractions && i < 10) {
      i++;
      qTextTemp = qText + ' #' + i;
    }
    qText = qText + ' #' + i;
  }

  try {
    qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
  } catch (e) {
    console.error('Error removing the last recorded text');
    getLogFromInjector();
  }

  questions.push({
    Question: qText,
    Type: qType,
    ExistingNote: qInteraction['ExistingNote'],
    Choices: qChoices
  });
  questionInteractions[qText] = qInteraction;
  registerFieldLeaf(
    question,
    flexLabel,
    {
      existing: qInteraction['ExistingNote'],
      input: (val, replyType) =>
        textBoxUpdate(getTextInputElement(question), val, replyType)
    },
    getTextInputElement(question)
  );
  if (!capturingValues) console.log('questions', questions);
}

async function scrapeTemplates(element, bodyPart, section) {
  console.log('Scraping Templates');
  // Get the template button
  var t = findTemplate(element);
  if (!t) {
    // console.log("Template button not found")
    return null;
  }

  t.click(); // Shows the template manager

  var tDialog = document.querySelector('.q-dialog');

  // Set the body part
  var bodyPartButton =
    tDialog.querySelectorAll('.q-field__inner')[0].firstChild;
  bodyPartButton.click();
  var lBox = document.querySelectorAll('[role="listbox"]')[0];
  var choicesSelector = lBox.querySelectorAll('.q-px-md');
  var choices = [];
  for (var i = 0; i < choicesSelector.length; i++) {
    var code = choicesSelector[i].children[0].textContent.trim();
    var description = choicesSelector[i].children[1].textContent.trim();
    choices.push(code + ' - ' + description);
  }
  var bodyPartIndex = choices.indexOf(bodyPart);
  if (bodyPartIndex == -1) {
    console.error('Body Part not found');
    return null;
  }
  choicesSelector[bodyPartIndex].click();

  // Set the section
  var sectionButton = tDialog.querySelectorAll('.q-field__inner')[1].firstChild;
  sectionButton.click();
  var lBox = document.querySelectorAll('[role="listbox"]')[0];
  var choicesSelector = lBox.querySelectorAll('.q-item__section');
  var choices = [];
  for (var i = 0; i < choicesSelector.length; i++) {
    var code = choicesSelector[i].children[0].textContent.trim();
    var description = choicesSelector[i].children[1].textContent.trim();
    choices.push(code + ' - ' + description);
  }
  var sectionIndex = choices.indexOf(section);
  if (sectionIndex == -1) {
    console.error('Section not found');
    return null;
  }
  choicesSelector[sectionIndex].click();

  // Get the templates
  var templates = tDialog.querySelector('.q-table__grid-content').children;
  var templates = [];
  for (var i = 0; i < templates.length; i++) {
    templates.push(templates[i].textContent.split('...see more')[0].trim());
  }

  // Close the template manager
  findElementOfTypeWithText(tDialog, 'i', 'close').click();

  return templates;
}

// function answerQuestions(answers){
export async function answerQuestions(answers) {
  /*
    Description: Populate every answer, one at a time, behind the blur overlay.

    Return: A list of any questions that were not answered
        [{ Question, Answer, Error }, ...]
    */
  const errors = [];
  beginOverlay(formatAnswerQueueMessage(), { title: 'ComprehendPT' });
  try {
    for (const answer of answers) {
      const result = await answerQuestion(answer['Question'], answer['Answer']);
      if (result !== true && result) {
        errors.push({
          Question: answer['Question'],
          Answer: answer['Answer'],
          Error: result
        });
      }
    }
    if (errors.length > 0) console.error('Errors:', errors);
    return errors;
  } finally {
    endOverlay();
  }
}

function normalizeKey(key: string): string {
  return key.replace(/[^\w\s]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
}

async function answerFlexQuestion(question, answer, replyType = 'overwrite') {
  const structure = questionInteractions[question]?.Structure || {};

  // Build a normalized lookup so AI keys like "Y Balance" match '"Y" Balance'
  const normalizedStructure: Record<string, any> = {};
  for (const key of Object.keys(structure)) {
    normalizedStructure[normalizeKey(key)] = structure[key];
  }

  for (const [fieldKey, fieldValue] of Object.entries(answer)) {
    const field = structure[fieldKey] ?? normalizedStructure[normalizeKey(fieldKey)];

    if (!field) {
      console.warn(`Flowsheet: field "${fieldKey}" not found in structure`);
      continue;
    }

    // fieldValue is a sub-object of {label: value} pairs for each treatment
    if (typeof fieldValue === 'object' && fieldValue !== null) {
      for (const [subKey, value] of Object.entries(fieldValue)) {
        const sub = field[subKey];
        if (!sub?.Input) {
          console.warn(`Flowsheet: sub-field "${fieldKey}.${subKey}" has no Input`);
          continue;
        }
        if (value !== null && value !== undefined && value !== '') {
          try {
            await sub.Input(String(value), replyType);
            await sleep(50);
            (document.activeElement as HTMLElement)?.blur();
          } catch (e) {
            console.error(`Flowsheet: error filling "${fieldKey}.${subKey}": ${e}`);
          }
        }
      }
    }
  }
}

export async function answerQuestion(question, answer, replyType) {
  beginOverlay(formatAnswerQueueMessage(), { title: 'ComprehendPT' });
  pushQuestionToQueue(String(question));
  try {
    return await answerQuestionInner(question, answer, replyType);
  } finally {
    removeQuestionFromQueue(String(question));
    endOverlay();
  }
}

async function answerQuestionInner(question, answer, replyType) {
  /*
    Description: This function will take the answer and populate the question
    
    Args: 
        question: The question in question
        answer: The answer to the question
   
    Return: null if success otherwise a string with the error message
    */

  await questionsLoadedPromise; // Wait for the questions to load

  console.log("Answering Question: '" + question + "' with '" + answer + "'");

  // Make sure the question exists
  if (questionInteractions[question] == null) {
    console.error('Question not found');
    console.log(questionInteractions);

    console.log(Object.keys(questionInteractions));

    return 'Question not found';
  }

  // flex++ section answer: walk the nested payload against that section's tree.
  if (flexSectionTrees[question]) {
    const section = flexSectionTrees[question];

    // The model normally answers in the shape it was given, but tolerate it
    // adding or dropping the section's own name at the root of the payload.
    let payload = answer;
    const namedRoot =
      payload !== null &&
      typeof payload === 'object' &&
      !Array.isArray(payload) &&
      Object.keys(payload).some(
        (key) => normalizeFlexKey(key) === normalizeFlexKey(question)
      );
    if (section.wrapped && !namedRoot) {
      payload = { [question]: payload };
    } else if (!section.wrapped && namedRoot && Object.keys(payload).length === 1) {
      payload = payload[Object.keys(payload)[0]];
    }
    if (question === GOALS_KEY || flexLookupChild(payload, GOALS_KEY) !== undefined) {
      payload = await ensureGoalRows(question, payload);
    }

    const errors = await fillFlexAnswer(section.tree, payload, replyType);
    if (errors.length > 0) {
      console.error(`[Prompt] flex++ fill errors for ${question}:`, errors);
    }
    return true;
  }

  // Flex question (e.g. Flowsheet)
  if (questionInteractions[question]['Type'] === 'Flex') {
    await answerFlexQuestion(question, answer, replyType);
    return true;
  }

  // If it is a Long Answer or long answer, just populate the input
  if (questionInteractions[question]['Input']) {
    // Tolerate a flex-shaped payload ({ Subjective: "..." }) for a plain field.
    if (answer && typeof answer === 'object' && !Array.isArray(answer)) {
      const keys = Object.keys(answer);
      if (keys.length === 1 && normalizeFlexKey(keys[0]) === normalizeFlexKey(question)) {
        answer = answer[keys[0]];
      }
    }
    questionInteractions[question]['Input'](answer, replyType);
    return true;
  }

  // Check if the answer is a list of answers or just a single answer
  if (Array.isArray(answer)) {
    // Choose All
    var notFoundAnswers = [];
    for (var i = 0; i < answer.length; i++) {
      if (answer[i] in questionInteractions[question]) {
        console.log('Answer found ' + answer[i]);
        await questionInteractions[question][answer[i]]();
        // sleep(1000).then(() => {
        //     questionInteractions[question][answer[i]]()
        // });
      } else {
        notFoundAnswers.push(answer[i]);
      }
    }
    // answer.forEach(element => {
    //     if (element in questionInteractions[question]){
    //         console.log("Answer found " + element)
    //         questionInteractions[question][element]()
    //     } else {
    //         notFoundAnswers.push(element)
    //     }
    // });
    if (notFoundAnswers.length > 0) {
      console.error('The following answers were not found: ' + notFoundAnswers);
      return 'The following answers were not found: ' + notFoundAnswers;
    } else {
      return true;
    }
  } else {
    // Multiple Choice
    if (answer in questionInteractions[question]) {
      questionInteractions[question][answer]();
      return true;
    } else {
      console.error('Answer not found');
      return 'Answer not found';
    }
  }
}

export async function getFlowsheet() {
  try {
    const check = 'Flowsheet';

    if (!questionInteractions[check]) {
      questionInteractions[check] = {
        Type: 'Flex',
        Key: check,
        Question: check,
        Structure: {},
        ReplyType: 'overwrite'
      };
      // Share the same Structure reference so localQuestions[key].Structure is populated
      questions.push({ Question: check, Type: 'Flex', Choices: [], Structure: questionInteractions[check].Structure });
    } else if (Object.keys(questionInteractions[check].Structure).length > 0) {
      console.log('Flowsheet already handled');
      return;
    }

    const structure = questionInteractions[check].Structure;

    // Wait for the flowsheet table to render (mirrors WebPTSoap2's revealFlowsheetTextarea pattern)
    let attempts = 0;
    while (
      !capturingValues &&
      document.querySelectorAll('table tbody tr').length === 0 &&
      attempts++ < 10
    ) {
      await sleep(400);
    }

    const rows = document.querySelectorAll('table tbody tr');
    if (!capturingValues) {
      console.log(`Flowsheet: found ${rows.length} row(s) after ${attempts} attempt(s)`);
    }

    rows.forEach((row, index) => {
      const nameEl = row.querySelector('.omni-type-s span');
      if (!nameEl) return;

      const rawName = nameEl.textContent?.trim() || `Treatment ${index + 1}`;
      let finalName = rawName;
      let counter = 2;
      while (structure[finalName]) {
        finalName = `${rawName} (${counter++})`;
      }

      const container = {};
      const seen = new Set<string>();

      const inputs = row.querySelectorAll('input, textarea');
      if (!inputs || inputs.length === 0) {
        console.warn(`Flowsheet row "${finalName}" has no inputs, skipping.`);
        return;
      }

      inputs.forEach((input: Element) => {
        const el = input as HTMLInputElement | HTMLTextAreaElement;
        const label = el.getAttribute('aria-label')?.trim();
        if (!label || seen.has(label)) return;
        seen.add(label);

        // CPT Code is a combobox — disabled for now
        if (label === 'CPT Code') {
          return;
        }

        // Textarea (Treatment Notes)
        if (el.tagName === 'TEXTAREA') {
          container[label] = {
            ...(el.value && { 'Existing Value': el.value }),
            Input: (val: string) => {
              bubbleFocus(el);
              nativeInputFill(el, val);
              el.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
              el.blur();
            }
          };
          return;
        }

        // All other inputs (Min., Set, Rep, Wt., Sec)
        const isNumeric = (el as HTMLInputElement).type === 'number';
        container[label] = {
          ...(isNumeric && { Type: 'Integer' }),
          ...(el.value && { 'Existing Value': el.value }),
          Input: (val: string) => {
            bubbleFocus(el);
            nativeInputFill(el as HTMLInputElement, val);
            el.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
            el.blur();
          }
        };
      });

      // Treatment Notes — rendered as a contenteditable div with a hidden sync textarea.
      // The input/textarea scan above never sees it: the hidden textarea has no aria-label.
      const noteCE = row.querySelector('.q-field__native div[contenteditable]') as HTMLElement | null;
      if (noteCE && !seen.has('Treatment Notes')) {
        seen.add('Treatment Notes');
        const hiddenTa = noteCE.parentElement?.querySelector('textarea') as HTMLTextAreaElement | null;
        const existingNote = noteCE.textContent?.trim() || hiddenTa?.value?.trim() || '';
        container['Treatment Notes'] = {
          ...(existingNote && { 'Existing Value': existingNote }),
          Input: (val: string) => {
            bubbleFocus(noteCE);
            noteCE.focus();
            // Select all existing content, then insertText so Vue's input listener
            // fires with a real editing event (works for contenteditable="plaintext-only")
            const sel = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(noteCE);
            sel?.removeAllRanges();
            sel?.addRange(range);
            const ok = document.execCommand('insertText', false, val);
            if (!ok || noteCE.textContent !== val) {
              // Fallback: set content directly and synthesize the input event
              noteCE.textContent = val;
              noteCE.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: val }));
            }
            // Keep the hidden textarea in sync in case the component reads from it
            if (hiddenTa && hiddenTa.value !== val) {
              nativeInputFill(hiddenTa, val);
            }
            noteCE.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
            noteCE.blur();
          }
        };
      }

      // Bodypart/Condition combobox
      const bodyPartInput = row.querySelector('input[aria-label="Bodypart/Condition"]') as HTMLInputElement | null;
      if (bodyPartInput) {
        container['Bodypart/Condition'] = {
          ...(bodyPartInput.value && { 'Existing Value': bodyPartInput.value }),
          Choices: ['Abdomen','Ankle','Arm','Back','Cervical','Chest','Elbow','Finger','Foot','Hand','Head','Hip','Jaw','Knee','Leg','N/A','Pelvis','Shoulder','Toe','Ulna','Wrist'],
          Input: async (val: string) => {
            if (bodyPartInput.value === val) return;
            const control = bodyPartInput.closest('.q-field__control') as HTMLElement | null;
            if (!control) return;
            control.dispatchEvent(eventFactory('focusin'));
            control.click();
            let a = 0;
            while (!document.querySelector('[role="listbox"]') && a++ < 20) {
              await sleep(100);
            }
            const listbox = document.querySelector('[role="listbox"]');
            if (!listbox) { control.click(); return; }
            // Focus + fill search box to filter (bypasses virtual scroll)
            const searchInput = listbox.querySelector('input[type="search"]') as HTMLInputElement | null;
            if (searchInput) {
              searchInput.focus();
              nativeInputFill(searchInput, val);
              await sleep(300);
            }
            for (const item of Array.from(listbox.querySelectorAll('.p-select__option-title'))) {
              if (item.textContent?.trim() === val) {
                (item as HTMLElement).click();
                return;
              }
            }
            control.click(); // close if not found
          }
        };
      }

      // Side (L / R) toggle buttons
      const sideGroup = (row.querySelector('.showDesktopPTable') ?? row.querySelector('.hideDesktopPTable')) as Element | null;
      if (sideGroup) {
        const sideBtns = Array.from(sideGroup.querySelectorAll('button'));
        const currentSide = sideBtns
          .find(b => b.classList.contains('bg-p-blue100'))
          ?.querySelector('.text-p-subtitle2')?.textContent?.trim();
        const sideChoices = sideBtns
          .map(b => b.querySelector('.text-p-subtitle2')?.textContent?.trim())
          .filter((s): s is string => !!s);
        if (sideChoices.length > 0) {
          container['Side'] = {
            ...(currentSide && { 'Existing Value': currentSide }),
            Choices: sideChoices,
            Input: (val: string) => {
              const target = sideBtns.find(b =>
                b.querySelector('.text-p-subtitle2')?.textContent?.trim() === val
              ) as HTMLElement | undefined;
              if (target && !target.classList.contains('bg-p-blue100')) {
                target.click();
              }
            }
          };
        }
      }

      // Performed / Not Performed
      const performedBtn = row.querySelector('[data-testid="button-exerciseCompleted"]') as HTMLElement | null;
      if (performedBtn) {
        const isPerformed = performedBtn.classList.contains('bg-p-green100');
        container['Performed'] = {
          'Existing Value': isPerformed ? 'Performed' : 'Not Performed',
          Choices: ['Performed', 'Not Performed'],
          Input: (val: string) => {
            // Re-query to avoid stale reference after Vue re-render
            const checkBtn = row.querySelector('[data-testid="button-exerciseCompleted"]') as HTMLElement | null;
            const currentlyPerformed = checkBtn?.classList.contains('bg-p-green100') ?? false;
            const wantPerformed = val === 'Performed';
            if (wantPerformed && !currentlyPerformed) {
              checkBtn?.click();
            } else if (!wantPerformed && currentlyPerformed) {
              (checkBtn?.previousElementSibling as HTMLElement | null)?.click();
            }
          }
        };
      }

      if (Object.keys(container).length > 0) {
        structure[finalName] = container;
        Object.entries(container).forEach(([label, def]: [string, any]) => {
          if (typeof def?.Input !== 'function') return;
          registerFlexLeaf({
            path: ['Flowsheet', finalName, label],
            existing: def['Existing Value'],
            choices: def.Choices,
            type: def.Type === 'Integer' ? 'integer' : undefined,
            input: def.Input
          });
        });
      }
    });

    if (!capturingValues) console.log('Flowsheet structure:', structure);
  } catch (e) {
    // A capture reads quietly: errors here would be relayed on every read.
    if (capturingValues) return;
    console.error(`Error in getFlowsheet: ${e}`);
    getLogFromInjector();
  }
}

function getExistingNote(value) {
  if (typeof value !== 'string') {
    return null;
  }

  let val = value?.trim();
  return val === '' ? null : val;
}

export async function getLogFromInjector() {
  try {
    const htmlContent = document.documentElement.outerHTML;
    return new Promise((resolve, reject) => {
      chrome.runtime.sendMessage(
        { type: 'INJECTOR_ERROR', error: { htmlContent: htmlContent } },
        (response) => {
          if (chrome.runtime.lastError) {
            reject(chrome.runtime.lastError);
          } else {
            resolve({ htmlContent: htmlContent });
          }
        }
      );
    });
  } catch (error) {
    // Return the full HTML content of the document
    console.error('Error occurred while fetching document:', error);
    return Promise.reject(error);
  }
}

/*
Get All Notes for the new Prompt integration (NoteFocusCapture.ts). Deliberately
not the *ForCapture exports: those also enable NoteCapture's poller and other
paths. The page facts come from PromptCapture.ts, shared with PromptInject; the
values come from this injector's own scrapers, so a captured note has exactly
the question keys and nesting getQuestions gives Comprehend, and a baseline
recorded after a fill lines up with every later capture.
*/
export const noteFocusCapture: FocusCaptureSource = {
  ...promptNotePage,
  readSection: readSectionForFocusCapture
};

/**
 * The entries of one document section, keyed like getQuestions: SOAP fields
 * as strings, the section's flex++ question as its nested values, goals as
 * lists. A collapsed measurement card cannot be read without opening it, so
 * its path is reported as kept rather than read.
 */
function readSectionForFocusCapture(section: string): SectionRead | null {
  if (!promptNotePage.listSections().includes(section)) return null;
  const note = sharedNoteRead();
  const owner = (key: string) => (key === GOALS_KEY ? 'All Goals' : key);
  const values: Record<string, any> = {};
  Object.entries(note.entries).forEach(([key, value]) => {
    if (note.owners.get(key) === section) values[key] = value;
  });
  return {
    values,
    keep: note.collapsedCards.filter((path) => owner(String(path[0])) === section)
  };
}

/*
Reading every section in one go (a note opening, a Comprehend link) would scrape
the whole note once per section. The page cannot change within one task, so
the reads in one task share a single scrape.
*/
let noteReadInTask: ReturnType<typeof readNoteForCapture> | null = null;

function sharedNoteRead() {
  if (!noteReadInTask) {
    noteReadInTask = readNoteForCapture();
    queueMicrotask(() => {
      noteReadInTask = null;
    });
  }
  return noteReadInTask;
}

/**
 * Every question getQuestions would return, with current values instead of
 * schemas. Runs the scrapers on private globals and never awaits, so the
 * fill state (questionInteractions, flexSectionTrees, goalRowCounts) is
 * untouched, and it never opens a card, clicks, focuses or waits.
 */
function readNoteForCapture() {
  const saved = {
    questions,
    questionInteractions,
    flexLeaves,
    flexBranchHints,
    flexDocTree,
    flexSectionTrees,
    flexPathSeen,
    flexHandled,
    flexRegisteredInputs,
    sectionIdCache,
    flexBranchTitles,
    goalRowCounts
  };
  questions = [];
  questionInteractions = {};
  flexLeaves = [];
  flexBranchHints = {};
  flexDocTree = {};
  flexSectionTrees = {};
  flexPathSeen = new Map();
  flexHandled = new WeakSet();
  flexRegisteredInputs = new WeakSet();
  sectionIdCache = null;
  flexBranchTitles = new Map();
  goalRowCounts = {};
  capturingValues = true;
  const owners = new Map<string, string>();
  const emptyLists: FlexPath[] = [];
  const collapsedCards: FlexPath[] = [];
  captureOwners = owners;
  captureEmptyLists = emptyLists;
  captureCollapsedCards = collapsedCards;
  try {
    // getQuestionsInner's order, minus fullscreen and opening collapsed cards.
    scrapeOpenMeasurementCards();
    scrapeGoalCards();
    scrapePlanOfCare();
    const blocks = document.querySelectorAll('.q-pa-md');
    for (let i = 1; i < blocks.length; i++) {
      const before = questions.length;
      // Every scraper this reaches finishes before its first await.
      extractQuestionBlock(blocks[i]).catch(() => {});
      questions.slice(before).forEach((question) => {
        if (question?.Question) owners.set(question.Question, sectionOf(blocks[i]));
      });
    }
    extractAllSectionComments();
    // With capturingValues set it never waits for the table, so it never awaits.
    void getFlowsheet();

    const entries: Record<string, any> = {};
    const entryOwners = new Map<string, string>();
    soapQuestions().forEach((question) => {
      const source = questions.find(
        (q) =>
          q?.Type === 'Long Answer' &&
          SOAP_SECTIONS[normalizeFlexKey(q.Question || '')] === question.Key
      );
      entries[question.Key] = question.ExistingNote ?? '';
      entryOwners.set(question.Key, owners.get(source?.Question) ?? '');
    });

    // buildFlexSectionQuestions' shape: a section of named fields is fronted,
    // a lone field or a list keeps the section's name as its root key.
    const tree: Record<string, any> = {};
    flexLeaves.forEach((leaf) => {
      if (leaf.path.length > 0 && leaf.path.length <= FLEXPP_MAX_DEPTH) {
        flexSetAtPath(tree, leaf.path, capturedLeafValue(leaf));
      }
    });
    emptyLists.forEach((path) => {
      if (flexGetAtPath(tree, path) === undefined) flexSetAtPath(tree, path, []);
    });
    Object.entries(tree).forEach(([key, subtree]) => {
      const wrapped =
        subtree === null || typeof subtree !== 'object' || Array.isArray(subtree);
      if (!wrapped && Object.keys(subtree).length === 0) return;
      entries[key] = wrapped ? { [key]: subtree } : subtree;
      entryOwners.set(key, key === GOALS_KEY ? 'All Goals' : key);
    });

    return { entries, owners: entryOwners, collapsedCards };
  } finally {
    ({
      questions,
      questionInteractions,
      flexLeaves,
      flexBranchHints,
      flexDocTree,
      flexSectionTrees,
      flexPathSeen,
      flexHandled,
      flexRegisteredInputs,
      sectionIdCache,
      flexBranchTitles,
      goalRowCounts
    } = saved);
    capturingValues = false;
    captureOwners = null;
    captureEmptyLists = null;
    captureCollapsedCards = null;
  }
}

/**
 * scrapeMeasurementCards without opening anything. A collapsed card that
 * getQuestions would open still takes its title, so the cards after it keep
 * the "#2" names getQuestions gives them.
 */
function scrapeOpenMeasurementCards() {
  const stats = { cards: 0, hidden: 0, expanded: 0, empty: 0, leaves: 0 };
  const cards = Array.from(document.querySelectorAll(MEASUREMENT_CARD_SELECTOR));
  for (const card of cards) {
    const title = claimMeasurementCard(card, stats);
    if (title === null) continue;
    if (card.querySelector(MEASUREMENT_FIELDS_SELECTOR)) {
      scrapeMeasurementCard(card, title);
    } else if (cardExpandToggle(card)) {
      const section = sectionOf(card);
      captureCollapsedCards?.push([section, uniqueBranchTitle(section, title)]);
    }
  }
  scrapeMeasurementTables();
}

function capturedLeafValue(leaf: FlexLeaf) {
  if (leaf.multiple) return leaf.selected ?? [];
  return leaf.existing ?? '';
}

function flexGetAtPath(root: any, path: FlexPath) {
  let node = root;
  for (const segment of path) {
    if (node === null || typeof node !== 'object') return undefined;
    node = node[segment as any];
  }
  return node;
}
